export const locale = {
    lang: "en",

    data: {
        COMMON: {
            EMAIL_PLACEHOLDER: "Enter Email",
            PASSWORD_PLACEHOLDER: "Enter Password",
            CONFIRM_PASSWORD_PLACEHOLDER: "Enter Confirm Password",
            SUBMIT_CAPS: "SUBMIT",
            COMING_SOON: "Coming Soon",
            SOON: "Soon",
        },

        PLACEHOLDER: {
            ENTER_ORGANISATION: "Enter Organisation",
            PHONE_NO: "Phone No.",
            ENTER_PHONE_NO: "Enter Phone No.",
            SELECT_PREFERRED_LANGUAGE: "Preferred Language",
            SELECT_TIMEZONE: "Timezone",
            STATE: "State",
            STATE_PROVINCE: "State/Province",
            POSTAL_CODE: "Postal Code",
            ENTER_POSTAL_CODE: "Enter Postal Code",
            ENTER_COUNTRY: "Search Country",
            ENTER_STATE: "Search State",
            ENTER_CITY: "Enter City",
            SEARCH_INDUSTRY: "Search Industry",
            SEARCH_PREFERRED_LANGUAGE: "Search Language",
            SEARCH_TIMEZONE: "Search Timezone",
            ENTER_STREET: "Enter Street",
            ENTER_FIRST_NAME: "Enter First name",
            ENTER_LAST_NAME: "Enter Last name",
            SELECT_DATE_OF_BIRTH: "Select Date Of Birth",
        },

        LOGIN: {
            TITLE: "MAKSELLENT Uygulamalarına Hoşgeldiniz!",
            DESCRIPTION:
                "MAKSELLENT Uygulamaları, Sabit Kıymet Yönetim Sistemi ile demirbaşlarınızın yönetimi artık daha kolay...",
            HEADER: "LOGIN TO YOUR ACCOUNT",
            ALREADY_ACCOUNT: "Please, Sign in if you already have an account",
            DONTHAVEACCOUNT: "Don't have an account?",
            CREATEACCOUNT: "Create an account",
            REGISTERCOMPANY: 'Corporate Demo Registration',
            EMAIL: "Email",
            PASSWORD: "Password",
            PASSCONFIRM: "Password (Confirm)",
            REMEMBERME: "Remember Me",
            FORGOTPASSWORD: "Forgot Password?",
            SIGNIN: "Sign in",
            SIGN_IN: "SIGN IN",
            SIGNUP: "Sign up",
            SIGN_UP: "SIGN UP",
            LANGUAGE: "Language",
            OR_SIGN_IN_WITH: "Sign In With",
            SIGN_IN_WITH_GOOGLE: "Sign in with Google",
            SYNC_WITH_GOOGLE: "Sync with Google",
        },

        REGISTER: {
            SIGN_UP: "Sign Up",
            LOGIN_INFORMATION: "Login Information",
            PROFILE_INFORMATION: "Profile Information",
            CONTACT_INFORMATION: "Contact Information",
            ADDRESS_INFORMATION: "Address Information",
            NEXT: "NEXT",
            ALREADY_ACCOUNT_SIGNUP: "Already have an account?",
            BACK: "BACK",
            HEADER: "CREATE AN ACCOUNT",
            STEPFIRST: "Fill out your login information",
            STEPPROFILE: "Fill out your profile",
            STEPCONTACT: "Fill out your contact details",
            STEPADDRESS: "Fill out your address",
            STEPDONE: "Done",
            FIRSTNAME: "First Name",
            LASTNAME: "Last Name",
            ORGANIZATION: "Organization",
            DATEofBIRTH: "Date of Birth",
            USERNAME: "Username",
            GENDER: "Gender",
            FEMALE: "Female",
            MALE: "Male",
            EMAIL: "E-Mail",
            PHONENUMBER: "Phone Number",
            PREFEREDLANG: "Prefered Language",
            ADDRESSCOUNTRY: "Country",
            ADDRESSCITY: "City",
            ADDRESSSTREET: "Street",
            HAVEACCOUNT: "Already have an account?",
            ACCEPT_TERMS: "I accpet",
            TERMS: "Terms Of Use",
            PRIVACY_POLICY: "Privacy Policy",
            VERIFY: "VERIFY",
            SIGNUP_SUCCESSFULLY: "Sign Up Successfully",
            SENT_ACTIVATION_CODE:
                "We have a sent activation code on your below email.",
            RETRY: "In case you didn’t get email retry after",
            MINUTES: "minutes.",
            RESEND_LINK: "RESEND",
            SIGNUP_COMPLETED: "You have completed signup successfully.",
            VERIFING_YOUR_ACCOUNT: "Verifing your account",
            LINK_EXPIRED:
                "Your activation link has expired, please click resend to get a new activation link.",
            AND: "and",
        },

        RECOVER: {
            TITLE: "Forgot Password",
            HEADER: "Recover Your Password",
            GOBACK: "Go back to login",
        },

        RESETPASS: {
            HEADER: "Reset Your Password",
            DESCRIPTION_OTP: "Enter the 6 digit OTP sent to your email",
        },

        BOTTON: {
            ADD: "Add",
            CREATE: "Create",
            SAVE: "Save",
            SAVE_AS: "Save As",
            CREATE_REPORT: "Create Report",
            EDIT: "Edit",
            DELETE: "Delete",
            FILTER: "Filter",
            RESET: "Reset",
            MAIN: "Main",
            LOGIN: "LOGIN",
            LOGINLINK: "Login",
            PASSWORDRESETLINK: "SEND RESET LINK",
            PASSWORDRESETBUTTON: "RESET MY PASSWORD",
            CREATEACCOUNT: "CREATE AN ACCOUNT",
            BACK: "Back",
            NEXT: "Next",
            SUBMIT: "Submit",
            CANCEL: "Cancel",
            APPLY: "Apply",
            COLLAPSE: "Collapse",
            EXPAND: "Expand",
            CLOSE: "Close",
            UPDATE: "Update",
            REMOVE: "Remove",
            UPLOAD: "Upload",
            COLORTAG: "Color Tag",
        },

        DEMO_ACTIVATION: {
            TITLE: "Workspace Management Applications",
            DESCRIPTION:
                "We want you to better understand our value proposition. Please use all aspects of the app to effectively consider the demo period and let us know if you need our support.",
            ALREADY_ACCOUNT: "If you already have a corporate account, ",
            BENEFITS_ONE: "Free use for 3 Months",
            BENEFITS_TWO: "No credit card",
            BENEFITS_THREE: "No commitment",
            TRY_NOW_BTN: "TRY NOW",
            COMPANY_NAME_LABEL: "Company Name",
            COMPANY_NAME_PLACEHOLDER: "Enter Company Name",
            SECTOR_LABEL: "Sector",
            ACTIVATION_CODE:
                "We have sent an activation code to your email address",
            INBOX_MSG: "In case you don't get email in your inbox for",
            ANOTHER_ACTIVATION_CODE:
                "minutes, please click to get another activation code.",
            ADDITIONAL_MSG:
                "Additionally, Please check your inbox for a separate email containing your company activation code which other company users must use during registration to the application if they will be using gmail, hotmail, yahoo kind of generic email accounts.",
            THANK_YOU: "Thank you!",
            REGISTRATION_COMPLETED:
                "You have completed tenant registration successfully.",
        },

        DIALOG: {
            NAMEREQUIRED: "Name is required",
            LASTNAMEREQUIRED: "Last Name is required",
            ORGANIZATIONREQUIRED: "Organization is required",
            EMAILREQUIRED: "Email is required",
            EMAILWARN: "Please enter a valid email address",
            EMAILMUSTCONTAIN:
                "Must contain (0,9) and [a,z] and [A,Z] and [!@#$%^&?_-|+>;€~¨] and at least 6 or more characters.",
            PASSWORDREQUIRED: "Password is required",
            PASSWORDCONFIRMREQUIRED: "Password confirmation is required",
            PASSWORDWARN: "Passwords must match",
            DATEOFBIRTHREQUIRED: "Date of Birth is required",
            DELETEWARN: "Do you really want to delete this record?",
            DELETESUCCESS: "Record successfully deleted!",
            DELETEFAILURE: "Problem during deletion",
            EDITABANDONED:
                "Unsaved changes will be lost. Are you sure to continue?",
            EDITSUCCESS: "Record successfully saved!",
            CREATESUCCESS:
                "Record successfully created. Please verify your Email!",
        },

        HEADER: {
            MY_TASKS: "My Tasks",
            MY_ASSETS: "My Assets",
            MY_ACCOUNTS: "My Accounts",
            MY_SHORTCUT: "My Shortcut N",
        },

        SIDEBAR: {
            TASKS: "Tasks",
            FIX_ASSETS: "Fix Assets",
            ACCOUNTS: "Accounts",
            SURVEY: "Survey",
            PRODUCTS: "Products",
            CONTACT: "Contact",
        },

        SYSTEM_SETTINGS_MENU: {
            MODULES: "Modules",
            ROLES: "Roles",
            INDUSTRY: "Industry",
            STATUS: "Status",
            LANGUAGE: "Language",
        },

        SYSTEM_SETTINGS_MODULES: {
            SETTINGS: "Settings",
            SEQUENCE: "Sequence",
            NAME: "Name",
            CODE: "Code",
            DESCRIPTION: "Description",
            ACTION: "Action",
            ACTIVATE: "Activate",
            DEACTIVATE: "Deactivate",
            SHOW_FILTER: "Show Filter",
            HIDE_FILTER: "Hide Filter",
            CLEAR_FILTER: "Clear Filter",
            RESULTS_FOUND: "results found",
            ENTER_NAME: "Enter Name",
            ENTER_CODE: "Enter Code",
            ENTER_DESCRIPTION: "Enter Description",
            ARE_YOU_SURE: "Are you sure?",
            ARE_YOU_SURE_DELETE: "Are you sure want to Delete",
            LANGUAGE_QUESTION_MARK: "Language?",
            ADD: "ADD",
            CSS_ICON: "CSS Icon",
            ENTER_CSS_ICON: "Enter CSS Icon",
            ASSIGN_MODULE: "Assign Module",
            ASSIGN_ROLE: "Assign Role",
            WARNING_ROLE:
                "No any modules added yet. Please add module for assign in the role.",
            WARNING_MODULE:
                "No any roles added yet. Please add role for assign in to the module.",
            MODULE: "Module",
            ROLE: "Role",
        },

        SURVEY_MODULES: {
            SURVEY: "Survey",
            SHOW_FILTER: "Show Filter",
            DOWNLOAD: "Download",
            HIDE_FILTER: "Hide Filter",
            CLEAR_FILTER: "Clear Filter",
            FILTER: "Filters",
            ADD: "ADD",
            EDIT: "EDIT",
            PREVIEW: "PREVIEW",
            RESPONSES: "RESPONSES",
            DELETE: "DELETE",
            CREATE_NEW: "Create New Survey",
            ADD_PAGE: "Add New Page",
            DRAFT: "Save as Draft",
            DELETE_PAGE: "DELETE Page",
            SAVE_PAGE: "Save Page",
            ADD_QUESTION: "Add New Question",
            NO_SURVEY: "No any survey added",
            TYPE: "Type",
            ACCESS_TYPE: "Access Type",
            SIZE: "Size",
            BUDGET: "Budget",
            NO_SURVEY_TEXT:
                "Excited to create your first survey? Let’s jump right in!",
            ADD_SURVEY: "ADD SURVEY",
            REQUIRED: "Required",
            ONLY_MY_SURVEY: "Only My Survey",
            MEMBER_LIST: "Member List",
            RESET_ALL: "Reset All",
            MENU: {
                BASIC_DETAIL: "Basic Details",
                DESIGN: "Design Survey",
                PREVIEW: "Preview",
                RESPONSE: "Responses",
                RESULT: "Result",
                SUMMARY: "Summary",
                DETAILS: "Details",
            },
            PLACEHOLDER: {
                ENTER_SURVEY_NAME: "Enter Survey Name",
                SELECT_SURVEY_TYPE: "Select Survey Type",
                SELECT_ACCOUNT: "Select Account",
                SELECT_ORGANIZATION: "Select Organization",
                SELECT_LOCATION: "Select Location",
                START_DATE: "Start Date",
                END_DATE: "End Date",
                CREATED_BY: "Created By",
                MODIFIED_BY: "Modified By",
            },
            VALIDATION: {
                QUESTION_REQUIRED: "This question cannot be left blank",
            },
        },

        IDEA: {
            IDEA_MANAGEMENT: "Idea Management",
            TOTAL_IDEAS: "Total Ideas",
            ADD_IDEA: "ADD IDEA",
            ADD_IDEA_SMALL: "Add Idea",
            CATEGORY: "Category",
            SUBMITTED_BY: "Submitted By",
            SUBMITTED_ON: "Submitted On",
            ATTACHMENTS: "ATTACHMENTS",
            ATTACHMENTS_SMALL: "Attachments",
            COMMENTS: "COMMENTS",
            UPVOTE: "UPVOTE",
            LIKE: "LIKE",
            GIVE_YOUR_COMMENT: "GIVE YOUR COMMENT",
            FILTERS: "Filters",
            SELECT_CATEGORY: "Select Category",
            TITLE: "Title",
            ENTER_TITLE: "Enter Title",
            DESCRIPTION: "Description",
            ENTER_YOUR_IDEA_DESCRIPTION: "Enter Your Idea Description",
            ATTACHMENT: "Attachment",
            SELECT_ATTACHMENT: "Select Attachment",
            SEARCH_IDEA: "Search Idea",
            ENTER_IDEA_NAME: "Enter Idea Name",
            ONLY_MY_IDEA: "Only My Idea",
            VIEW_MORE: "VIEW MORE",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            SELECT_START_DATE: "Select Start Date",
            SELECT_END_DATE: "Select End Date",
            NO_ANY_IDEA_ADDED: "No any idea added",
            NO_ANY_IDEA_DESC: "Excited to create your first task? Let's jump right in!"
        },

        PACKAGE: {
            SETTINGS: "Settings",
            MONTHLY: "Monthly",
            ANNUALLY: "Annually",
            ASSIGN_MODULES: "ASSIGN MODULES",
            ACTIVE: "Active",
            DEACTIVE: "Deactive",
            USER_MANAGEMENT: "User Management",
            ADD_FREE_TEXT: "ADD FREE TEXT",
            DELETE_PACKAGE: "DELETE PACKAGE",
            PACKAGE: "Package",
            PLAN_TYPE: "Plan Type",
            SELECT_PLAN_TYPE: "Select plan type",
            PRICE: "Price",
            ENTER_PRICE: "Enter price",
            FREE_TEXT_IN_PACKAGE: "free text in package",
            TEXT: "Text",
            ENTER_TEXT: "Enter Text",
            BUY_PLAN: "Buy Plan",
            CHOOSE_PLAN: "Choose Plan",
            ORDER_DETAILS: "Order Details",
            COMPANY_DETAILS: "Company Details",
            PAYMENT_DETAIL: "Payment Details",
            PER_USER: "per user",
            BUY_NOW: "Buy Now",
            USERS: "Users",
            CHANGE: "CHANGE",
            BASIC_PACKAGE: "Basic Package",
            ORDER_SUMMARY: "Order Summary",
            BASIC_PLAN: "Basic Plan",
            SUB_TOTAL: "Sub Total",
            GRAND_TOTAL: "Grand Total",
            ADDRESS_STREET: "Address Street",
            ENTER_ADDRESS_STREET: "Enter Address Street",
            COUNTRY: "Country",
            SELECT_COUNTRY: "Select Country",
            SELECT_STATE: "Select State",
            SELECT_CITY: "Select City",
            LEGAL_ENTITY: "Legal Entity",
            PRIVATE_COMPANY: "Private Company",
            TAX_OFFICE: "Tax Office",
            ENTER_TAX_OFFICE: "Enter Tax Office",
            TAX_ID: "Tax ID",
            NATIONAL_ID: "National ID",
            ENTER: "Enter",
            OFFICE_PHONE_NO: "Office Phone no.",
            ENTER_OFFICE_PHONE_NO: "Enter Office Phone no.",
            MOBILE_NO: "Mobile no.",
            ENTER_MOBILE_NO: "Enter Mobile no.",
            Fax: "Fax",
            ENTER_FAX: "Enter Fax",
            CREDIT_CARD: "Credit Card",
            NET_BANKING: "Net Banking",
            CARD_HOLDER_NAME: "Card Holder Name",
            ENTER_CARD_HOLDAR_NAME: "Enter Card Holder Name",
            CARD_NUMBER: "Card Number",
            ENTER_CARD_NUMBER: "Enter Card Number",
            MM: "MM",
            YYYY: "YYYY",
            CVC: "CVC",
            ENTER_CVC: "Enter CVC",
            NOTE: "Note",
            ORDER_NUMBER: "Order Number",
            NET_BANKING_TITLE:
                "MAKSELLENT LTD. - Remittance / EFT bank account information",
            NET_BANKING_CONTENT: "Yapı & Kredi Bank (USD Account)",
            IBAN_TOP: "IBAN: TR22 0006 7010 0000 0044 1380 97",
            IBAN_BOTTOM: "IBAN: TR83 0006 7010 0000 0088 0942 95",
            NOTE_DESCRIPTION_TOP:
                "The purchase will be completed after the Remittance / EFT transaction is completed. Please specify your",
            NOTE_DESCRIPTION_BOTTOM:
                "order number in the Remittance / EFT description.",
            IDEA_MANAGEMENT: "Idea Management",
            TOTAL_IDEAS: "Total Ideas",
            ADD_IDEA: "ADD IDEA",
            CATEGORY: "Category",
            SUBMITTED_BY: "Submitted By",
            SUBMITTED_ON: "Submitted On",
            ATTACHMENTS: "ATTACHMENTS",
            ATTACHMENTS_SMALL: "Attachments",
            COMMENTS: "COMMENTS",
            UPVOTE: "UPVOTE",
            LIKE: "LIKE",
            GIVE_YOUR_COMMENT: "GIVE YOUR COMMENT",
            FILTERS: "Filters",
            SELECT_CATEGORY: "Select Category",
            TITLE: "Title",
            ENTER_TITLE: "Enter Title",
            DESCRIPTION: "Description",
            ENTER_YOUR_IDEA_DESCRIPTION: "Enter Your Idea Description",
            ATTACHMENT: "Attachment",
            SELECT_ATTACHMENT: "Select Attachment",
            SEARCH_IDEA: "Search Idea",
            ENTER_IDEA_NAME: "Enter Idea Name",
            ONLY_MY_IDEA: "Only My Idea",
            VIEW_MORE: "VIEW MORE",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            SELECT_START_DATE: "Select Start Date",
            SELECT_END_DATE: "Select End Date",
        },

        VALIDATION: {
            EMAIL_REQUIRED: "Please enter a valid email address",
            PASSWORD_REQUIRED: "Password is required",
            PASSWORD_MIN_LENGTH: "Password minimum length 8",
            CONFIRM_PASSWORD_REQUIRED: "You need to confirm your password",
            CONFIRM_PASSWORD_NOT_MATCHED:
                "Password and Password confirmation do not match!",
            VALID_INDUSTRY: "Please select a valid industry",
            VALID_COUNTRY: "Please select a valid country",
            VALID_STATE: "Please select a valid state",
            VALID_LANGUAGE: "Please select a valid language",
            VALID_TIMEZONE: "Please select a valid timezone",
            NAME_REQUIRED: "Name is required",
            CONFIRM_ADD_DATA: "Are you sure want to Add New Data",
            CONFIRM_ARCHIVE_DATA: "Are you sure want to Archive Data",
            CONFIRM_UNSAVED_CHANGE:
                "Unsaved changes will be lost. Are you sure to continue?",
            CONFIRM_TITLE: "Are you sure",
            CONFIRM_TITLE_UNSAVED_CHANGE: "Unsaved Change",
            PLEASE_ENTER_VALID_EMPLOYEE_TYPE:
                "Please enter valid employee type",
            PLEASE_ENTER_VALID_DEPARTMENT: "Please enter valid department",
            PLEASE_ENTER_VALID_COST_CENTRE: "Please enter valid cost centre",
            PLEASE_ENTER_VALID_ACCOUNT: "Please enter valid account",
            PLEASE_ENTER_VALID_ORGANIZATION: "Please enter valid organization",
            PLEASE_ENTER_VALID_UNIT: "Please enter valid unit",
            PLEASE_ENTER_VALID_LOCATION: "Please enter valid location",
            PLEASE_ENTER_VALID_ZONE: "Please enter valid zone",
            PLEASE_ENTER_VALID_TASK_NAME: "Please enter valid task name",
            PLEASE_ENTER_VALID_EXPENSE_TYPE_NAME:
                "Please enter valid expense type name",
            PLEASE_ENTER_VALID_USER_NAME: "Please enter valid user name",
            EXPENSE_CATEGORY: "Expense category is required",
            EXPENSE_TYPE: "Expense type is required",
            PROOF: "Proof is required",
            USER_NAME: "User name is required",
            ASSIGN_TO: "Assign to is required",
            AMOUNT: "Amount to is required",
            PLEASE_ENTER_VALID_BANK: "Please enter valid bank",
            PLEASE_ENTER_VALID_CURRENCY: "Please enter valid currency",
            PREFIX_REQUIRED: "Prefix is required"
        },

        APP_SETTINGS: {
            ADD_ACCOUNT: "Add Account",
            NAME: "Name",
            ADD_ZONE: "Add Zone",
            ADD_ORGANIZATION: "Add Organisation",
            ADD_UNIT: "Add Unit",
            ADD_LOCATION: "Add Location",
            APP_SETTING: "App Settings",
            ADD: "Add",
            PROFILE: "Profile",
            ENTER_NAME: "Enter Name",
            TENNANT: "Tenant",
            STATUS: "Status",
            DESCRIPTION: "Description",
            ENTER_DESCRIPTION: "Enter Description",
            LOCATION: "Location",
            ENTER_LOCATION: "Enter location",
            COUNTRY: "Country",
            CITY: "City",
            STREET: "Street",
            ENTER_STREET: "Enter Street",
            CONTACT: "Contact",
            EMAIL: "Email",
            ENTER_EMAIL: "Enter Email",
            PHONE_NO: "Phone no.",
            ENTER_PHONE_NO: "Enter Phone no.",
            DOCUMENTS: "Documents",
            SELECT_ATTACHMENTS: "Select Attachments",
            ACCOUNT_NAME: "Account name",
            ENTER_ACCOUNT_NAME: "Enter account name",
            ORGANIZATION: "Organization",
            ENTER_ORGANIZATION_NAME: "Enter organisation name",
            ZONE_NAME: "Zone name",
            ENTER_ZONE_NAME: "Enter zone name",
            MOBILE_NUMBER: "Mobile Number",
            ENTER_MOBILE_NUMBER: "Enter Mobile Number",
            SELECT_UNIT_CAPITAL: "Select Unit",
            SELECT_ZONE_CAPITAL: "Select Zone",
            SELECT_ROLE: "Select Role",
            POWER_USER: "Power User",
            SELECT_ALL: "Select All",
            IMPORT: "Import",
            MOBILE_NO: "Mobile No.",
            ROLES: "ROLES",
            MEMBER: "Member",
            TASK_MANAGER: "Task manager",
            HR_MANAGER: "HR manager",
            ASSET_MANAGER: "Asset manager",
            FILE_MANAGER: "File manager",
            LOCATION_CAPITAL: "LOCATION",
            PEPSICO: "Pepsico",
            USER_MANAGEMENT: " User Management",
            PROSPECTS: "Prospects"
        },

        SURVEY_TARGET: {
            SURVEY_TARGET: "Survey Target",
            ADD_TARGET: "Add Target",
            ENTER_NAME: "Enter Name",
            NO_OF_DATA: "No. Of Data",
            IMPORT_DATA: "Import Data",
            ADD_SURVEY_TARGET: "Add Survey Target",
            PREVIOUS_CUSTOMER_LIST: "Previous Customer List",
            SELECT_FILE: "Select file",
            DOWNLOAD_SAMPLE_FILE: "Download Sample File",
            CSV: ".csv",
            XSLX: ".xslx",
            WANT_TO_SAVE_FILE_IN_SYSTEM: "Want to save file in system",
            SEND_EMAIL: "Send Email",
            NAME: "Name",
            SURNAME: "Surname",
            JOB_TITLE: "Job Title",
            NATIONAL_ID: "National ID",
            Description: "Description",
            SEARCH_FIRST_NAME: "Search first name",
            SEARCH_LAST_NAME: "Search last name",
            SELECT_GENDER: "Select Gender",
            SEARCH_EMAIL: "Search email",
            SEARCH_PHONE_NO: "Search phone no",
            CHOOSE_DATE: "Choose date",
        },

        PROFILE: {
            PROFILE: "Profile",
            MYPROFILE: "My profile",
            PREFERENCES: "My Preferences",
            ASSETS: "My Assets",
            BANK_ACCOUNT: "My Bank Account",
            CHANGE_PASSWORD: "Change Password",
            CHANGE_PROFILE: "Change Profile",
            ADD_PICTURE: "Add Picture",
            CHANGE_PICTURE: "Change Picture",
            CHOOSE_DATE: "Choose Date",
            ENTER_NATIONAL_ID: "Enter National ID",
            UPDATE: "UPDATE",
            RESET: "RESET",
            OLD_PASSWORD: "Old Password",
            ENTER_OLD_PASSWORD: "Enter Old Password",
            NEW_PASSWORD: "New Password",
            ENTER_NEW_PASSWORD: "Enter New Password",
            CONFIRM_PASSWORD: "Confirm Password",
            DEPARTMENT: "Department",
            SELECT_DEPARTMENT: "Select Department",
            ORGANIZATION: "Organisation",
            SELECT_ORGANIZATION: "Select Organisation",
            ACCOUNT: "Account",
            SELECT_ACCOUNT: "Select Account",
            EMPLOYEMENT_INFORMATION: "Employment Information",
            EMPLOYEE_ID: "Employee id",
            ENTER_EMPLOYEE_ID: "Enter employee id",
            JOB_TITLE: "Job Title",
            ENTER_JOB_TITLE: "Enter job title",
            TYPE_OF_EMPLOYEE: "Type of Employee",
            SELECT_EMPLOYEE: "Select employee",
            MANAGER: "Manager",
            SELECT_MANAGER: "Select manager",
            COST_CENTER: "Cost Center",
            SELECT_COST_CENTER: "Select cost center",
            ENTER_ORGANIZATION: "Enter organization",
            ENTER_UNIT: "Enter Unit",
            ENTER_ZONE: "Enter Zone",
            OFFICE_NO: "Office no",
            ENTER_OFFICE_NO: "Enter office no",
            ENTER_PHONE_NUMBER: "Enter phone number",
            PROVINCE_CODE: "Province code",
            ENTER_PROVINCE_CODE: "Enter province code",
            EXPENSES: "Expenses",
            ONLY_MY: "Only My",
            PAID_EXPENSE: "Paid Expense",
            UNPAID_EXPENSE: "Unpaid Expense",
            TASK_NAME: "Task Name",
            ASSIGN_TO: "Assign To",
            AMOUNT: "Amount",
            PAID_AMOUNT: "Paid Amount",
            PAYMENT_DATE: "Payment Date",
            SELECT_TASK: "Select task",
            SELECT: "Select",
            ENTER: "Enter",
            SELECT_USER: "Select User",
            SELECT_PAYMENT_STATUS: "Select Payment Status",
            SELECT_PAYMENT_RANGE: "Select Payment Range",
            SELECT_DATE_RANGE: "Select Date Range",
            SELECT_PAYMENT_TYPE: "Select Payment Type",
            PAYMENTS: "Payments",
            BANK_ACCOUNTS: "Bank Accounts",
            FULL_NAME: "Full Name",
            ENTER_FULL_NAME: "Enter full name",
            BANK_NAME: "Bank Name",
            IBAN: "IBAN",
            ENTER_IBAN: "Enter IBAN",
            CURRENCY: "Currency",
            SELECT_CURRENCY: "Select currency",
            SELECT_BANK: "Select Bank",
            SELECT_BANK_SMALL: "Select bank",
            BRANCH_CODE: "Branch Code",
            ENTER_BRANCH_CODE: "Enter branch code",
            ACCOUNT_CODE: "Account code",
            ENTER_ACCOUNT_CODE: "Enter account code",
            ENTER_FULL_NAME_AS_NATIONAL_ID_CARD:
                "Enter Full name as National Id Card",
            USER_NAME: "User Name",
            SELECT_AMOUNT: "Select Amount",
            SELECT_PAID_AMOUNT: "Select Paid Amount",
            MY_EXPENSES: "My Expenses",
            APPROVE_SELECTED: "Approve Selected",
            CUSTOMER: "Customer",
            CUSTOMER_CAPITAL: "CUSTOMER",
            EXPENSE_TYPE: "Expense Type",
            SELECT_EXPENSE_TYPE: "Select Expense Type",
            PROOF: "Proof",
            SELECT_PROOF: "Select Proof",
            SELECT_USER_NAME: "Select User Name",
            MIN_AMOUNT_PAID: "Min Amount Paid",
            SELECT_MIN_AMOUNT_PAID: "Select Min Amount Paid",
            MAX_AMOUNT_PAID: "Max Amount Paid",
            SELECT_MAX_AMOUNT_PAID: "Select Max Amount Paid",
            MIN_AMOUNT: "Min Amount",
            SELECT_MIN_AMOUNT: "Select Min Amount",
            MAX_AMOUNT: "Max Amount",
            SELECT_MAX_AMOUNT: "Select Max Amount",
            ENTER_YOUR_COMMENT: "Enter your comment",
            CLONE: "Clone",
            APPROVE: "Approve",
            VALID_EXPENSE_CATEGORY: "Please enter valid expense category name",
            ASSET_MANAGEMENT: "Asset Management"
        },

        MY_FILE: {
            UPLOAD_FILE: "Upload File",
            CREATE_FOLDER: "Create Folder",
            FOLDER_NAME: "Folder name",
            ENTER_FOLDER_NAME: "Enter folder name",
            MY_FILES: "My Files",
            CREATE_NEW_FOLDER: "Create New Folder",
            FOLDERS: "FOLDERS",
            FILES_SMALL: "Files",
            FILES_CAPITAL: "FILES",
            FILE_TYPE: "File type",
            FILE_SIZE: "File size",
            UPDATED_BY: "Updated by",
            UPDATED_ON: "Updated on",
            MODIFIED_ON: "Modified on",
            ARCHIVE: "Archive",
            EMPTY_TRASH_NOW: "Empty trash now",
            NO_FOLDER_TEXT: "No any folder added yet",
            NO_FILE_TEXT: "No any file added yet",
            SHARE: "Share",
            DELETE_FOREVER: "Delete Forever",
            UNDO: "Undo",
            TRASH: "Trash",
            OTHER_INFORMATION: "Other Information",
            SELECT_TAGS: "Select tags",
            SELECT_ACCESS_MODIFIER: "Select access modifier",
            SELECT_FILES: "Select Files",
            MARK_AS_UNFAVOURITE: "Mark as unfavourite",
            MARK_AS_MAIN: "Mark as main",
        },

        SURVEY_RESULT: {
            SURVEY_RESULT: "Survey Results",
            RESPONDENTS: "RESPONDENTS",
            OF: "of",
            PRINT: "Print",
            ANSWERED: "Answered",
            SKIPPED: "Skipped",
            TOTAL: "TOTAL",
        },

        FIX_ASSET: {
            THUMBNAIL: "Thumbnail",
            ASSET_CODE: "Asset Code",
            ENTER_ASSET_CODE: "Enter Asset Code",
            BRAND: "Brand",
            MODEL: "Model",
            SERIAL_NUMBER: "Serial Number",
            DEFINITION: "Definition",
            ENTER_DEFINITION: "Enter definition",
            MODIFICATION_DATE: "Modification Date",
            CATEGORIZATION: "Categorization",
            CATEGORIZATION_CAPITAL: "CATEGORIZATION",
            COMMENT: "Comment",
            TRANSFER: "Transfer",
            EXCEL: "Excel",
            CSV: "CSV",
            JSON: "json",
            TXT: "Txt",
            PRODUCT_FAMILY: "Product family",
            ADD_PRODUCT_FAMILY: "Add Product family",
            ENTER_PRODUCT_FAMILY: "Ürün ailesini girin",
            IT_EQUIPMENTS: "IT equipments",
            PRODUCT_CATEGORY: "Product category",
            ADD_PRODUCT_CATEGORY: "Add Product category",
            ENTER_PRODUCT_CATEGORY: "Enter product category",
            COMPUTERS: "Computers",
            PRODUCT_LINE: "Product line",
            ADD_PRODUCT_LINE: "Add Product line",
            ENTER_PRODUCT_LINE: "Enter product line",
            LAPTOP: "Laptop",
            PRODUCT_TYPE: "Product type",
            ADD_PRODUCT_TYPE: "Add Product type",
            ENTER_PRODUCT_TYPE: "Enter product type",
            XSD: "XSD",
            ORGANISATION_HIERARCHY: "Organization Hierarchy",
            ACCOUNT: "Account",
            ZONE: "Zone",
            SELECT_ZONE: "Select zone",
            PRODUCT_GROUP: "Product Group",
            ENTER_PRODUCT_GROUP: "Enter product group",
            PRODUCT: "Product",
            ENTER_PRODUCT: "Enter product",
            ASSET: "ASSET",
            ASSET_STATUS: "Asset Status",
            SELECT_ASSET_STATUS: "Select asset status",
            ASSET_USAGE: "Asset Usage",
            ENTER_COMPANY_ASSET_CODE: "Enter Company Asset Code",
            COMPANY_ASSET_CODE: "Company Asset Code",
            MASTER_ASSET_CODE: "Master Asset Code",
            ENTER_MASTER_ASSET_CODE: "Enter Master Asset Code",
            GENERAL: "GENERAL",
            STATUS_DETAILS: "Status Details",
            SELECT_STATUS_DETAILS: "Select status detail",
            STATUS_DETAIL: "Status Detail",
            EMPLOYEE: "Employee",
            ADD_BRAND: "Add Brand",
            ENTER_BRAND: "Enter Brand",
            ADD_MODEL: "Add Model",
            ENTER_MODEL: "Enter Model",
            ENTER_SERIAL_NUMBER: "Enter Serial Number",
            COMMENTS: "Comments",
            ENTER_COMMENT: "Enter comment",
            BASIC_DEFINITIONS: "Basic Definitions",
            STATUS_LIABILITY: "Status/Liability",
            ADD_STATUS_LIABILITY: "Add Status/Liability",
            MAINTENANCE: "Maintenance",
            INSURANCE: "Insurance",
            FINANCIAL_DETAILS: "Financial Details",
            PHOTOS_DOCUMENTS: "Photos/Documents",
            FIRM_ASSET_CODE: "Firm asset code",
            ENTER_FIRM_ASSET_CODE: "Enter firm asset code",
            MAIN_ASSET_CODE: "Main asset code",
            ENTER_MAIN_ASSET_CODE: "Enter main asset code",
            EXPLANATION: "Explanation",
            ENTER_EXPLANATION: "Enter explanation",
            WIDTH: "Width",
            ENTER_WIDTH: "Enter width",
            HEIGHT: "Height",
            ENTER_HEIGHT: "Enter height",
            LENGTH: "Length",
            ENTER_LENGTH: "Enter length",
            QUANTITY: "Quantity",
            ENTER_QUANTITY: "Enter quantity",
            UNIT: "Unit",
            SELECT_UNIT: "Select unit",
            ASSET_LOCATION: "Asset Location",
            START_DATE: "Start Date",
            END_DATE: "End Date",
            LIABLE_EMPLOYEE: "Liable Employee",
            SELECT_LIABLE_EMPLOYEE: "Select liable employee",
            ASSET_ATTRIBUTE: "Asset Attribute",
            SELECT_ASSET_ATTRIBUTE: "Select asset attribute",
            TYPE: "Type",
            VENDOR: "Vendor",
            MAINTENANCE_DATE: "Maintenance Date",
            NEXT_MAINTENANCE_DATE: "Next Maintenance Date",
            COMPLETION_DATE: "Completion Date",
            SET_REMINDER: "Set Reminder",
            CUSTOM: "Custom",
            ADD_REMINDER: "Add Reminder",
            CHOOSE_TIME: "Choose Time",
            ENTER_NOTE: "Enter Note",
            ADD_ASSET_MAINTENANCE: "Add Asset Maintenance",
            MAINTENANCE_TYPE: "Maintenance type",
            SELECT_MAINTENANCE_TYPE: "Select maintenance type",
            MAINTENANCE_VENDOR: "Maintenance vendor",
            INSURANCE_COMPANY: "Insurance Company",
            ENTER_INSURANCE_COMPANY: "Enter insurance company",
            POLICY_NUMBER: "Policy Number",
            ENTER_POLICY_NUMBER: "Enter policy number",
            AGENT_NAME: "Agent Name",
            ENTER_AGENT_NAME: "Enter agent name",
            POLICY_TYPE: "Policy Type",
            ADD_ASSET_INSURANCE: "Add Asset Insurance",
            SCANNER_CODE: "Scanner Code",
            GENERATE_NEW_CODE: "GENERATE NEW CODE",
            QR_CODE: "QR code",
            BARCODE: "Barcode",
            RFID_CODE: "RFID code",
            UNIQUE_KEY: "Unique Key",
            SELECT_LOCATION: "Select Location",
            ENTER_POLICY_TYPE: "Enter policy type",
            REMINDER: "Reminder",
            NEXT_WEEK: "Next week",
            TOMORROW: "Tomorrow",
            IN: "In",
            HOURS: "hours",
            MINUTES: "minutes",
            APPLY: "APPLY",
            UPLOAD: "UPLOAD",
            SEE_ALL_PHOTOS: "SEE ALL PHOTOS",
            SHARE: "SHARE",
            UPLOAD_PHOTO_DOCUMENT: "Upload Photo/Document",
            UPLOAD_PHOTO_DOCUMENT_TEXT:
                "Select any one to set as an asset main photo",
            NO_FIX_ASSETS: "No any fix assets added",
            NO_FIX_ASSETS_TEXT:
                "Excited to create your first fix asset? Let’s jump right in!",
            ADD_FIX_ASSET: "ADD FIX ASSET",
            SEE_ARCHIVE: "See Archive File",
            INITIAL_COST: "Initial Cost",
            ENTER_INITIAL_COST: "Enter Initial cost",
            ACQUISTONO_DATE: "Acquistino Date",
            BOOK_VALUE: "Book Value",
            CURRENT_VALUE: "Current Value",
            AMORTIZATION: "Amortization",
            FISCAL_YEAR_END: "Fiscal year end",
            ENTER_FISCAL_YEAR_END: "Enter Fiscal year end",
            MONTHLY_AMORTISATION: "Monthly amortisation",
            ENTER_MONTHLY_AMORTISATION: "Enter Monthly amortisation",
            MONTHLY_HELD: "Monthly held",
            ENTER_MONTHLY_HELD: "Enter Monthly held",
            DATE_ACQUIRED: "Date acquired",
            DATE_OF_DISPOSITION: "Date of disposition",
            PERIOD: "Period",
            MONTH_THIS_PERIOD: "Months this period",
            AMORTIZATION_THIS_PERIOD: "Amortization this period",
            ACCUMULATED_AMORTIZATION: "Accumulated Amortization",
            NET_BOOK_VALUE: "Net book value",
            REVALUATION: "Revaluation",
            INVOICE_COST: "Invoice Cost",
            REVALUATION_FACTOR: "Revaluation Factor(%)",
            REVALUATION_DATE: "Revaluation Date",
            SELECT_UNIT_CAPITAL: "Select Unit",
            NO_FIX_ASSETS_DESC: "Excited to create your first fix asset? Let's jump right in!",
            ADD_ASSETS: "ADD FIX ASSETS",
            CLONE_ASSETS: "CLONE FIX ASSET",
            NAME: "Name",
            DESCRIPTION: "Description",
            SHARE_FILES: "Share Files",
        },

        TASK_MANAGEMENT: {
            PROJECT_MEMBERS: "project members",
            TEAM: "Team",
            NO_ANY_TEAM_ARE_AVAILABLE: "No any team are available",
            build_a_team_and_add_resources: "Build a team and add resources.",
            BUILD: "BUILD",
            CREATE: "CREATE",
            CREATE_TEAM: "Create team",
            EDIT_TEAM: "Edit team",
            TEAM_NAME: "Team name",
            ENTER_TEAM_NAME: "Enter team name",
            SEARCH_USERS: "Search users",
            INVITE: "INVITE",
            SR_NO: "Sr. No.",
            MEMBERS: "Members",
            CREATE_NEW_BOARD: "Create new board",
            UPDATE_BOARD: "Update board",
            BOARD_NAME: "Board Name",
            ENTER_BOARD_NAME: "Enter board name",
            CHOOSE_BACKGROUND: "Choose Background",
            REMOVE_FROM_FAVOURITE: "Remove from favourite",
            DELETE_BOARD: "Delete board",
            NAME_YOUR_PROJECT: "Name your project",
            CREATE_PROJECT_TEXT:
                "You can change these details anytime in your project settings.",
            PROJECT_NAME: "Project name",
            ENTER_PROJECT_NAME: "Enter project name",
            PREFIX: "Prefix",
            ENTER_PREFIX: "Enter prefix",
            TYPE_OF_PROJECT: "Type of project",
            LIMIT_OF_RESOURCES: "Limit of resources",
            COLOR: "Color",
            PRIVATE_PROJECT: "Private project",
            SAVE_NEXT: "SAVE & NEXT",
            NO_ANY_USERS_ARE_AVAILABLE: "No any users are available",
            INVITE_USERS_TEXT: "Invite user now and add in to any project.",
            VIEW_PROFILE: "View profile",
            INVITE_USER: "Invite user",
            INVITE_TEAMMATES: "Invite teammates",
            ENTER_EMAIL_ADDRESSES: "Enter email addresses",
            MESSAGE: "Message",
            MESSAGE_PLACEHOLDER:
                "Include a personal message with your invitation",
            INVITE_SMALL: "Invite",
            MANAGE_TEAM_FOR: "Manage team for",
            ADD_TEAMMATES: "Add teammates",
            ENTER_TEAMMATES: "Enter teammates",
            PROJECTS: "Projects",
            NO_PROJECT: "No any projects added",
            NO_PROJECT_TEXT:
                "Excited to create your first project? Let’s jump right in!",
            ADD_PROJECT: "ADD PROJECT",
            SEE_MEMBERS: "SEE MEMBERS",
            VIEW_TASKS: "View tasks",
            MANAGE_TEAM: "Manage team",
            KEY: "Key",
            CREATED_BY: "Created By",
            BOARD: "Board",
            ADD_MEMBERS: "Add members",
            SHARE_TASK: "Share task",
            NAME_OR_EMAIL: "Name or email",
            ENTER_NAME_OR_EMAIL: "Enter name or email",
            ADD_A_MESSAGE: "Add a message",
            FLAGGED: "Flagged",
            EDIT_TASK: "Edit task",
            EDIT_COLOR: "Edit color",
            CONVERT_TO_SUB_TASK: "Convert to sub task",
            COPY_TASK_LINK: "Copy task link",
            MOVE_IN: "Move in",
            DUPLICATE_TASK: "Duplicate task",
            ADD_FLAG: "Add flag",
            REMOVE_COLOR_TAG: "Remove Color Tag",
            ENTER_TASK_BRIEF: "Enter Task Brief",
            ADD_SUBTASK: "Add Subtask",
            CHECKLIST: "Checklist",
            ASSIGNEE: "Assignee",
            UNASSIGNED: "Unassigned",
            REPORTER: "Reporter",
            TAGS: "Tags",
            ENTER_NEW_TAG: "Enter new tag",
            PRIORITY: "Priority",
            DUE_DATE: "Due Date",
            CREATED: "Created",
            UPDATED: "Updated",
            RESOLVED: "Resolved",
            ACTIVITY: "Activity",
            NEWEST_FIRST: "Newest first",
            OLDEST_FIRST: "Oldest first",
            ALL: "All",
            HISTORY: "History",
            TYPE_A_COMMENT: "Type a comment",
            DELETE_ALL: "Delete All",
            DOWNLOAD_ALL: "Download All",
            ATTACHMENT_TEXT: "No any attachments are added",
            ADD_AN_ITEM: "Add an item",
            ADDED: "added",
            CHANGED: "changed",
            HISTORY_CAPITAL: "HISTORY",
            IN_PROGRESS: "In progress",
            COMMENT_CAPITAL: "COMMENT",
            SUB_TASKS: "Sub tasks",
            MARK_AS_FAVOURITE: "Mark as favourite",
            OPEN_BOARD: "Open Board",
            ADD_SECTION: "Add Section",
            ADD_TASK: "ADD TASK",
            SEARCH: "Search",
            ONLY_MY_ISSUE: "ONLY MY ISSUE",
            RECENTLY_UPDATED: "RECENTLY UPDATED",
            LABEL: "LABEL",
            TASK: "Task",
            SUBTASK: "Subtask",
            COLOR_CAPITAL: "COLOR",
            CLEAR_FILTERS: "CLEAR FILTERS",
            GROUP_BY: "GROUP BY",
            COMPLETED: "Completed",
            INCOMPLETED: "Incomplete",
            RENAME: "Rename",
            ENTER_TEXT: "Enter text",
            ASSIGN_TEAM: "Assign team",
            ASSIGN_MEMBER: "Assign member",
            MARK_AS_MILESTONE: "Mark as Milestone",
            ENTER_TASK_NAME: "Enter task name",
            TAG: "TAG",
            PRODUCT_MANAGEMENT: "Product management",
            PROJECT_TYPE: "Project Type",
            PROJECT_KEY: "Project Key",
            SEARCH_PROJECT_KEY: "Search Project Key",
            PUBLIC_PROJECT: "Public Project",
            MODIFIED_BY: "Modified By",
            ONLY_MY_PROJECT: "Only My Project",
            SHOW_ONLY_FAVOURITE: "Show Only Favourite",
            PRIVATE: "Private",
            PUBLIC: "Public",
            DEFAULT: "Default",
            STATUS_CAPITAL: "STATUS",
            CREATED_ON: "Created on",
            QUICK_CREATE_TEAM: "Quick Create Team",
            TEAM_DESCRIPTION: "Team Description",
            PICK_MEMBERS: "Pick members",
            SELECT_MEMBERS: "Select members",
            VISIBILITY: "Visibility",
            ACCESS_MODIFIER: "Access Modifier",
            TEAMS: "Teams",
            UI_UX_TEAM_MEMBERS: "(UI/UX team members)",
            ADD_BOARD: "Add board",
            SELECT_TEAM: "Select team",
            ADD_TEAM: "Add team",
            SEARCH_TO_ADD_MEMBER_TO_TEAM: "Search to add member to team",
            SELECT_ALL_CAPITAL: "SELECT ALL",
            NO_ANY_MEMBERS_ARE_ADDED: "No any members are added",
            PICK_FROM_USERS_LIST_AND_ASSIGNED_IN_TO_THE_TEAM:
                "Pick from users list and assigned in to the team",
            ADD_ATTACHMENT: "Add attachment",
            ADD_CHECKLIST: "Add checklist",
            TASK_ESTIMATION: "Task estimation(in hrs)",
            ADD_DESCRIPTION: "Add a description",
            ENTER_TASK_ESTIMATION: "Enter task estimation",
            NONE: "None",
            PROGRESS: "Progress",
            ADD_EXPENSE: "Add Expense",
            EXPENSE_TYPE: "Expense Type",
            SELECT_EXPENSE_TYPE: "Select Expense Type",
            EXPENSE_AMOUNT: "Expense Amount",
            ENTER_EXPENSE_AMOUNT: "Enter Expense Amount",
            ARCHIVE_BOARD: "Archive Board",
            ADD_TO_CONTACTS: "Add to Contact",
            NO_ANY_USER_ARE_ADDED: "No any users are added",
            SHOW_USERS_TEAM: "Show Users/Teams",
            SHOW_TEAM: "Show team",
            EXPENSE_CATEGORY: "Expense Category",
            TO_DO: "To Do's",
            ALL_TASK_MANGEMENT: "All",
            SECTION: "Section",
            SELECT_PROJECT: "Select Project",
            ONLY_CREATED_BY_ME: "Only created by me",
            ONLY_ASSIGNED_TO_ME: "Only assigned to me",
            ONLY_REPORTED_TO_ME: "Only reported to me",
            ONLY_ME_AS_A_TEAM_MEMBER: "Only me as a team member",
            IN_PROGRESS_CAPITAL: "IN PROGRESS",
            DONE: "DONE",
            TO_DO_CAPITAL: "TO DO",
            DUE_ON: "Due on",
            REPORT_NAME: "Report Name",
            SELECT_REPORT_NAME: "Select report name",
            NAME: "Name",
            CONTACT_DETAILS: "Contact Details",
            USE_COMMA_TO_SEPERATE_INVITATION_ACCOUNTS: "Use comma to seperate invitation accounts",
            FAVORITE: "Favorite",
            RECURRING: "Recurring",
            SELECT_DUE_DATE: "Select Due Date",
            NAVIGATIONAL: "NAVIGATIONAL",
            SELECT_BOARD: "Select Board",
            SELECT_SECTION: "Select Section",
            PARENT: "Parent",
            SELECT_PARENT: "Select Parent",
            OWNERSHIP_MEMBERSHIP: "OWNERSHIP/MEMBERSHIP",
            REPORTED_TEAM: "Reported Team",
            SELECT_REPORTED_TEAM: "Select Reported Team",
            OWNER_USER: "Owner User",
            SELECT_OWNER_USER: "Select Owner User",
            REPORTED_USER: "Reported User",
            SELECT_REPORTED_USER: "Select Reported User",
            ASSIGNED_USER: "Assigned User",
            SELECT_ASSIGNED_USER: "Select Assigned User",
            SELECT_CREATED_BY: "Select Created By",
            SELECT_MODIFIED_BY: "Select Modified By",
            TASK_CATEGORY: "Category",
            SELECT_CATEGORY: "Select Category",
            TASK_SUB_CATEGORY: "Sub Category",
            SELECT_SUB_CATEGORY: "Select Sub Category"
        },

        DASHBOARD_FIX_ASSETS: {
            WELCOME: "Welcome",
            BRANDS: "Counts By Brand",
            CATEGORY_COUNT: "Counts By Category",
            ASSET_BYSTATUS_COUNT: "Counts by Status",
            COUNT: "Count",
            NOTIFICATIONS: "Notifications",
            REMINDERS: "Reminders",
            ADDED: "added",
            A: "a",
            ON: "on",
            UPVOTE: "Upvote",
            SHOW_MORE: "Show more",
            DUE_INSURANCE: "Due insurance",
            DATE: "Date",
            DUE_MAINTENANCE: "Due maintenance",
            NO_NOTIFICATION: "No any recent notification",
            NO_REMINDER: "No any recent reminder",
            NO_INSURANCE: "No any insurance found",
            NO_MAINTENANCE: "No any maintenance found",
            NO_DATA: "Herhangi bir veri bulunamadı",
        },

        SYSTEM_NAVIGATION: {
            HOME: "Home",
            DASHBOARD: "Dashboard",
            MY_SURVEY: "My Survey",
            MY_IDEAS: "My Ideas",
            TENANTS: "Tenants",
            MY_PROFILE: "My Profile",
            LOGOUT: "Logout",
            TASK_MANAGEMENT: "Task Management",
            TASK_MANAGEMENT_DESC:
                "Manage your tasks in its life cycle. Plan, test, track and report. Achieve your individual goals or collaborate with your teammates.",
            SURVEY_MANAGEMENT: "Survey Management",
            SURVEY_MANAGEMENT_DESC:
                "Design, manage and publish professional surveys and collect feedback to provide assistance in your business decision making process",
            FIX_ASSET_MANAGEMENT_DESC:
                "Track and maintain your organizational units physical assets and equipment. Monitor their statuses, employee liabilities, maintenance, insurance and financial life cycle.",
            IDEA_MANAGEMENT_DESC:
                "Generate, capture, discuss and improve. Organize, evaluate and prioritize valuable insight or alternative thinking process.",
            PRODUCT_MANAGEMENT_DESC:
                "Manage essential product details that help buyers make a purchase decision. Product features, descriptions, dimensions, price, weight, availability, color, customer reviews, and more..",
            ACCOUNT_MANAGEMENT_DESC:
                "Manage your prospects and customers. Retain clients' business and grow those opportunities. Help them to achieve their goals.",
            CONTACT_MANAGEMENT_DESC:
                "Enable your users to easily store and find contact information on the accounts they have been managing, such as names, addresses, and telephone numbers. Track all activities linked to contacts.",
            FILE_MANAGER: "File Manager",
            FILE_MANAGER_DESC:
                "Administer your company's digital data, collaborate effectively. Manage business flow with organized important data in a searchable database.",
            PROFILE_MANAGEMENT_DESC:
                "Manage your profile, preferences, contact information. Submit your expenses and be aware of your compensation and received payments.",
            MESSAGES: "Messages",
            MARK_ALL_AS_READ: "Mark all as read",
            MARK_ALL_AS_UNREAD: "Mark as unread",
            MUTE_MESSAGES: "Mute Messages",
            DELETE_MESSAGE: "Delete Message",
            VIEW_ALL: "View All",
            MUTE_NOTIFICATION: "Mute Notification",
            MUTE_REMINDER: "Mute Reminder",
            MARK_AS_READ: "Mark as read",
            DELETE_NOTIFICATION: "Delete Notification",
            LAST_LOGGED_IN: "Last logged in:",
            LOCALE_ACCOUNTS: "On-premises Accounts",
            USER_MANAGEMENT: "User Management",
            PURCHASE_MANAGEMENT: "Purchase Management",
            PURCHASE_MANAGEMENT_DESC:
                "Manage your processes effectively so that your products and services are provided in the right quality, in the right quantity, at the right time, at the right price and from the right source.",
            REMINDERS: "Reminders",
            MARK_AS_READ_UNREAD: "Mark as Read/Unread",
            CHANGE_REMINDER: "Change reminder",
            TEAM_MANAGEMENT: "Team Management",
            TEAM_MANAGEMENT_DESC:
                "Help team members keep track of their assignments and waste less time. Improve communication and manage budget effectively",
            CALENDAR: "Calendar",
            CALENDAR_DESC:
                "Manage your events, reminders, personal to-does and your team tasks with easy to use, simple to share, packed with features calendar app",
            INTERNAL_ACCOUNTS: "Internal Accounts",
            PROSPECT_ACCOUNTS: "Prospects",
            CUSTOMER_ACCOUNTS: "Customer Accounts",
            SEARCHING: "Searching...",
            BIP_BOUNTY_HUNTERS: "BIP - Bounty Hunters",
            BIP_BOUNTY_HUNTERS_DESC: "Only real bounty hunters can win prizes here.",
        },

        PROFILE_STATUS: {
            ONLINE: "Online",
            AWAY: "Away",
            IN_A_MEETING: "In a Meeting",
            COMMUTING: "Commuting",
            OFFLINE: "Offline",
            OUT_OF_OFFICE: "Out of Office",
            DO_NOT_DISTURB: "Do Not Disturb",
        },

        PURCHASE_MANAGEMENT: {
            PURCHASE_INVOICE: "Purchase Invoice",
            INVOICE_NO: "Invoice No.",
            DOCUMENT_TYPE: "Document type",
            PROJECT: "Project",
            ENTER_PROJECT: "Enter Project",
            DATE_OF_ISSUE: "Date Of Issue",
            EXPIRY_DATE: "Expiry Date",
            INVOICE_AMOUNT: "Invoice Amount",
            LOCAL_AMOUNT: "Local Amount",
            BALANCE: "Balance",
            HEADER_TITLE: "HEADER",
            DETAILS_TITLE: "DETAILS",
            TOTALS_TITLE: "TOTALS",
            FILE_PHOTOS: "FILE/PHOTOS",
            INVOICE_DETAILS: "INVOICE DETAILS",
            SELECT_TAGS_NEW: "Select Tags",
            NEW_TAG: "New tag",
            UPLOAD_DOCUMENT: "Upload Document",
            ADDRESS: "Address",
            ENTER_ADDRESS: "Enter Address",
            ORDER_NO: "Order No.",
            ENTER_ORDER_NO: "Enter Order No.",
            ORDER_DATE: "Order Date",
            WAYBILL_DETAILS: "WAYBILL DETAILS",
            WAYBILL_NO: "Waybill No.",
            ENTER_WAYBILL_NO: "Enter Waybill No.",
            WAYBILL_DATE: "Waybill Date",
            ADD_NEW: "ADD NEW",
            ENTER_PRODUCT_NAME: "Enter Product Name",
            UNIT_PRICE: "Unit Price",
            VAT_RATE: "VAT Rate",
            TOTAL_VAT_AMOUNT: "Total VAT Amount",
            TOTAL_EXCLUDING_VAT: "Total(Excluding VAT)",
            TOTAL_INCLUDING_VAT: "Total(Including VAT)",
            ENTER_IN_DOLLAR: "Enter (in $)",
            ENTER_IN_PERCENTAGE: "Enter (in %)",
            CURRENCY_TOTALS: "Currency Totals",
            IN_USD: "(IN USD)",
            SUBTOTAL: "Subtotal",
            LINE_DISCOUNT: "Line Discount",
            GROSS_TOTAL: "Gross Total",
            TOTAL_NET_FEE: "Total Net Fee",
            TOTAL_VAT_EIGHT: "Total Vat (8.00%)",
            TOTAL_VAT_EIGHTEEN: "Total Vat (18.00%)",
            LOCAL_TOTALS: "Local Totals",
            CURRENT_ACCOUNT: "Current Account",
            ENTER_CURRENT_ACCOUNT: "Enter Current Account",
            SERIAL_NO: "Serial No.",
            ENTER_SERIAL_NO: "Enter Serial No.",
            PAYMENT_STATUS: "Payment Status",
            TRACKING_CURRENCY: "Tracking Currency",
            SELECT_TRACKING_CURRENCY: "Select Tracking Currency",
            SELECT_CURRENT_ACCOUNT_NAME: "Select Current Account Name",
        },

        TERMS_SERVICES: {
            MAKSELLENT_TERMS_OF_SERVICE: "MAKSELLENT TERMS OF SERVICE",
            EFFECTIVE_DATE: "EFFECTIVE: November 10, 2021",
            PARAGRAPH_ONE:
                "IMPORTANT, READ CAREFULLY : YOUR USE OF AND ACCESS TO THE WEBSITE AND PRODUCTS AND SERVICES AND ASSOCIATED SOFTWARE (COLLECTIVELY, THE “SERVICES”) OF MAKSELLENT VIDEO COMMUNICATIONS, INC. AND ITS AFFILIATES (“MAKSELLENT”) IS CONDITIONED UPON YOUR COMPLIANCE WITH AND ACCEPTANCE OF THESE TERMS, WHICH INCLUDE YOUR AGREEMENT TO ARBITRATE CLAIMS. PLEASE REVIEW THOROUGHLY BEFORE ACCEPTING.",
            PARAGRAPH_TWO:
                "BY CLICKING/CHECKING THE “I AGREE” BUTTON/BOX, ACCESSING THE MAKSELLENT WEBSITE OR BY UTILIZING THE MAKSELLENT SERVICES YOU AGREE TO BE BOUND BY THESE TERMS OF SERVICE AND ALL EXHIBITS, ORDER FORMS, AND INCORPORATED POLICIES (THE “AGREEMENT” OR “TOS”). THE MAKSELLENT SERVICES ARE NOT AVAILABLE TO PERSONS WHO ARE NOT LEGALLY ELIGIBLE TO BE BOUND BY THESE TERMS OF SERVICE.",
            PARAGRAPH_THREE:
                "Maksellent will provide the Services, and you may access and use the Services, in accordance with this Agreement. Maksellent may provide any of the Services hereunder through any of its Affiliates. If You order Services through an on-line registration page or an order form (each an “Order Form”), the Order Form may contain additional terms and conditions and information regarding the Services you are ordering. Unless otherwise expressly set forth in any such additional terms and conditions applicable to the specific Service which You choose to use, those additional terms are hereby incorporated into this Agreement in relation to Your use of that Service.",
            SYSTEM_REQUIREMENTS: "System Requirements",
            SYSTEM_REQUIREMENTS_DESCRIPTION:
                "Use of the Services requires one or more compatible devices, Internet access (fees may apply), and certain software (fees may apply), and may require obtaining updates or upgrades from time to time. Because use of the Services involves hardware, software, and Internet access, Your ability to access and use the Services may be affected by the performance of these factors. High speed Internet access is recommended. You acknowledge and agree that such system requirements, which may be changed from time to time, are Your responsibility.",
            DEFINITIONS: "DEFINITIONS",
            DEFINITIONS_ONE:
                "The following definitions will apply in this Agreement, and any reference to the singular includes a reference to the plural and vice versa. Service specific definitions are found in the Services Description located at",
            DEFINITIONS_TW0:
                "“Affiliate” means, with respect to a Party, any entity that directly or indirectly controls, is controlled by or is under common control with that Party. For purposes of this Agreement, “control” means an economic or voting interest of at least fifty percent (50%) or, in the absence of such economic or voting interest, the power to direct or cause the direction of the management and set the policies of such entity.",
            DEFINITIONS_THREE:
                "“End User” means a Host or Participant (as defined in the Services Description) who uses the Services.",
            DEFINITIONS_FOUR:
                "“Initial Subscription Term” means the initial subscription term for a Service as specified in an Order Form.",
            DEFINITIONS_FIVE:
                "“Service Effective Date” means the date an Initial Subscription Term begins as specified in an Order Form.",
            DEFINITIONS_SIX:
                "“Renewal Term” means the renewal subscription term for a Service commencing after the Initial Subscription Term or another Renewal Term as specified in an Order Form.",
            DEFINITIONS_SEVEN: "/services-description.",
            SERVICES: "SERVICES",
            SERVICES_DESCRIPTION:
                "Maksellent will provide the Services as described on the Order Form, and standard updates to the Services that are made generally available by Maksellent during the term. Maksellent may, in its sole discretion, discontinue the Services or modify the features of the Services from time to time without prior notice.",
            BETA_SERVICES: "Beta Services",
            BETA_SERVICES_DESCRIPTION:
                "Maksellent may, from time to time, offer access to services that are classified as Beta version. Access to and use of Beta versions may be subject to additional agreements. Maksellent makes no representations that a Beta version will ever be made generally available and reserves the right to discontinue or modify a Beta version at any time without notice. Beta versions are provided AS IS, may contain bugs, errors or other defects, and Your use of a Beta version is at Your sole risk.",
            USE_OF_SERVICES_AND_YOUR_RESPONSIBILITIES:
                "USE OF SERVICES AND YOUR RESPONSIBILITIES",
            USE_OF_SERVICES_AND_YOUR_RESPONSIBILITIES_DESCRIPTION:
                "You may only use the Services pursuant to the terms of this Agreement. You are solely responsible for Your and Your End Users’ use of the Services and shall abide by, and ensure compliance with, all Laws in connection with Your and each End User’s use of the Services, including but not limited to Laws related to recording, intellectual property, privacy and export control. Use of the Services is void where prohibited.",
            REGISTRATION_INFORMATION: "Registration Information",
            REGISTRATION_INFORMATION_DESCRIPTION:
                "You may be required to provide information about Yourself in order to register for and/or use certain Services. You agree that any such information shall be accurate. You may also be asked to choose a user name and password. You are entirely responsible for maintaining the security of Your user name and password and agree not to disclose such to any third party.",
            YOUR_CONTENT: "Your Content",
            YOUR_CONTENT_DESCRIPTION:
                "You agree that You are solely responsible for the content (“Content”) sent or transmitted by You or displayed or uploaded by You in using the Services and for compliance with all Laws pertaining to the Content, including, but not limited to, Laws requiring You to obtain the consent of a third party to use the Content and to provide appropriate notices of third party rights. You represent and warrant that You have the right to upload the Content to Maksellent and that such use does not violate or infringe on any rights of any third party. Under no circumstances will Maksellent be liable in any way for any (a) Content that is transmitted or viewed while using the Services, (b) errors or omissions in the Content, or (c) any loss or damage of any kind incurred as a result of the use of, access to, or denial of access to Content. Although Maksellent is not responsible for any Content, Maksellent may delete any Content, at any time without notice to You, if Maksellent becomes aware that it violates any provision of this Agreement, or any law. You retain copyright and any other rights You already hold in Content which You submit, post or display on or through, the Services.",
            RECORDINGS: "Recordings",
            RECORDINGS_DESCRIPTION:
                "You are responsible for compliance will all recording laws. The host can choose to record Maksellent meetings and Webinars. By using the Services, you are giving Maksellent consent to store recordings for any or all Maksellent meetings or webinars that you join, if such recordings are stored in our systems. You will receive a notification (visual or otherwise) when recording is enabled. If you do not consent to being recorded, you can choose to leave the meeting or webinar",
            PROHIBITED_USE: "Prohibited Use",
            PROHIBITED_USE_DESCRIPTION:
                "You agree that You will not use, and will not permit any End User to use, the Services to: (i) modify, disassemble, decompile, prepare derivative works of, reverse engineer or otherwise attempt to gain access to the source code of the Services; (ii) knowingly or negligently use the Services in a way that abuses, interferes with, or disrupts Maksellent’s networks, Your accounts, or the Services; (iii) engage in activity that is illegal, fraudulent, false, or misleading, (iv) transmit through the Services any material that may infringe the intellectual property or other rights of third parties; (v) build or benchmark a competitive product or service, or copy any features, functions or graphics of the Services; or (vi) use the Services to communicate any message or material that is harassing, libelous, threatening, obscene, indecent, would violate the intellectual property rights of any party or is otherwise unlawful, that would give rise to civil liability, or that constitutes or encourages conduct that could constitute a criminal offense, under any applicable law or regulation; (vii) upload or transmit any software, Content or code that does or is intended to harm, disable, destroy or adversely affect performance of the Services in any way or which does or is intended to harm or extract information or data from other hardware, software or networks of Maksellent or other users of Services; (viii) engage in any activity or use the Services in any manner that could damage, disable, overburden, impair or otherwise interfere with or disrupt the Services, or any servers or networks connected to the Services or Maksellent’s security systems. (ix) use the Services in violation of any Maksellent policy or in a manner that violates applicable law, including but not limited to anti-spam, export control, privacy, and anti-terrorism laws and regulations and laws requiring the consent of subjects of audio and video recordings, and You agree that You are solely responsible for compliance with all such laws and regulations.",
            LIMITATIONS_ON_USE: "Limitations on Use",
            LIMITATIONS_ON_USE_DESCRIPTION:
                " You may not reproduce, resell, or distribute the Services or any reports or data generated by the Services for any purpose unless You have been specifically permitted to do so under a separate agreement with Maksellent. You may not offer or enable any third parties to use the Services purchased by You, display on any website or otherwise publish the Services or any Content obtained from a Service (other than Content created by You) or otherwise generate income from the Services or use the Services for the development, production or marketing of a service or product substantially similar to the Services.",
            RESPONSIBILITY_FOR_END_USERS: "RESPONSIBILITY FOR END USERS",
            RESPONSIBILITY_FOR_END_USERS_ONE:
                "You are responsible for the activities of all End Users who access or use the Services through your account and you agree to ensure that any such End User will comply with the terms of this Agreement and any Maksellent policies. Maksellent assumes no responsibility or liability for violations. If You become aware of any violation of this Agreement in connection with use of the Services by any person, please contact Maksellent at",
            RESPONSIBILITY_FOR_END_USERS_TWO:
                "Maksellent may investigate any complaints and violations that come to its attention and may take any (or no) action that it believes is appropriate, including, but not limited to issuing warnings, removing the content or terminating accounts and/or User profiles. Under no circumstances will Maksellent be liable in any way for any data or other content viewed while using the Services, including, but not limited to, any errors or omissions in any such data or content, or any loss or damage of any kind incurred as a result of the use of, access to, or denial of access to any data or content.",
            MAKSELLENT_OBLIGATIONS_FOR_CONTENT:
                "MAKSELLENT OBLIGATIONS FOR CONTENT",
            MAKSELLENT_OBLIGATIONS_FOR_CONTENT_DESCRIPTION:
                "Maksellent will maintain reasonable physical and technical safeguards to prevent unauthorized disclosure of or access to Content, in accordance with industry standards. Maksellent will notify You if it becomes aware of unauthorized access to Content. Maksellent will not access, view or process Content except (a) as provided for in this Agreement and in Maksellent’s Privacy Statement; (b) as authorized or instructed by You, (c) as required to perform its obligations under this Agreement; or (d) as required by Law. Maksellent has no other obligations with respect to Content.",
            ELIGIBILITY: "ELIGIBILITY",
            ELIGIBILITY_DESCRIPTION:
                "You affirm that You are at least 16 years of age and are otherwise fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in this Agreement, and to abide by and comply with this Agreement.  Your access may be terminated without warning if we believe that You are under the age of 16 or are otherwise ineligible.",
            INTENDED_USE_RESTRICTION_ON_USE_BY_CHILDREN:
                "INTENDED USE; RESTRICTION ON USE BY CHILDREN",
            INTENDED_USE_RESTRICTION_ON_USE_BY_CHILDREN_DESCRIPTION:
                "The Services are intended for business use. You may choose to use the Services for other purposes, subject to the terms and limitations of this Agreement. Maksellent is not intended for use by individuals under the age of 16, unless it is through a School Subscriber (as that term is defined in the Services Description) using Maksellent for Education (K-12).",
            CHARGES_AND_CANCELLATION: "CHARGES AND CANCELLATION",
            CHARGES_AND_CANCELLATION_DESCRIPTION:
                "You agree that Maksellent may charge to Your credit card or other payment mechanism selected by You and approved by Maksellent (“Your Account”) all amounts due and owing for the Services, including taxes and service fees, set up fees, subscription fees, or any other fee or charge associated with Your Account. Unless stated otherwise, all prices and fees shown by Maksellent are exclusive of taxes and regulatory fees, service, service fees, set up fees, subscription fees, or any other fee or charge associated with Your Account. Where applicable, taxes and regulatory fees will be charged on the invoices issued by Maksellent in accordance with local laws and regulations. The taxes and regulatory fees charged can be changed without notice.  All payments made by you to us under this Agreement will be made free and clear of any deduction or withholding, as may be required by law. If any such deduction or withholding (including but not limited to domestic or cross-border withholding taxes) is required on any payment, you will pay such additional amounts as are necessary so that the net amount received by us is equal to the amount then due and payable under this Agreement. We will provide you with such tax forms as are reasonably requested in order to reduce or eliminate the amount of any withholding or deduction for taxes in respect of payments made under this Agreement.  Maksellent may change prices at any time, including changing from a free service to a paid service and charging for Services that were previously offered free of charge; provided, however, that Maksellent will provide you with prior notice and an opportunity to terminate Your Account if Maksellent changes the price of a Service to which you are subscribed and will not charge you for a previously free Service unless you have been notified of the applicable fees and agreed to pay such fees. You agree that in the event Maksellent is unable to collect the fees owed to Maksellent for the Services through Your Account, Maksellent may take any other steps it deems necessary to collect such fees from You and that You will be responsible for all costs and expenses incurred by Maksellent in connection with such collection activity, including collection fees, court costs and attorneys’ fees. You further agree that Maksellent may collect interest at the lesser of 1.5% per month or the highest amount permitted by law on any amounts not paid when due. You may cancel your subscription at any time. If you cancel, you will not be billed for any additional terms of service, and service will continue until the end of the current Subscription Term. If you cancel, you will not receive a refund for any service already paid for.",
            TERMINATION: "TERMINATION",
            TERMINATION_DESCRIPTION:
                "The Maksellent website contains information on how to terminate Your Account. If you have purchased a Service for a specific term, such termination will be effective on the last day of the then-current term. Your Order Form may provide that a Renewal Term will begin automatically unless either party provides notice of termination at least thirty (30) days prior to the commencement of the next Renewal Term. If You fail to comply with any provision of this Agreement, Maksellent may terminate this Agreement immediately and retain any fees previously paid by You. Sections 1 and 3 through 20, inclusive, shall survive any termination of this Agreement. Upon any termination of this Agreement, You must cease any further use of the Services. If at any time You are not happy with the Services, Your sole remedy is to cease using the Services and follow this termination process.",
            PROPRIETARY_RIGHTS: "PROPRIETARY RIGHTS",
            PROPRIETARY_RIGHTS_DESCRIPTION:
                "Maksellent and/or its suppliers, as applicable, retain ownership of all proprietary rights in the Services and in all trade names, trademarks, service marks, logos, and domain names (“Maksellent Marks”) associated or displayed with the Services. You may not frame or utilize framing techniques to enclose any Maksellent Marks, or other proprietary information (including images, text, page layout, or form) of Maksellent without express written consent. You may not use any meta tags or any other “hidden text” utilizing Maksellent Marks without Maksellent’s express written consent.",
            COPYRIGHT: "COPYRIGHT",
            COPYRIGHT_DESCRIPTION:
                "You may not post, modify, distribute, or reproduce in any way copyrighted material, trademarks, rights of publicity or other proprietary rights without obtaining the prior written consent of the owner of such proprietary rights. Maksellent may deny access to the Services to any User who is alleged to infringe another party’s copyright. Without limiting the foregoing, if You believe that Your copyright has been infringed, please notify Maksellent as specified here.",
            EXPORT_RESTRICTIONS: "EXPORT RESTRICTIONS",
            EXPORT_RESTRICTIONS_DESCRIPTION:
                "You acknowledge that the Services, or a portion thereof, are subject to the Export Administration Regulations, 15 C.F.R. Parts 730-774, of the United States and may be subject to other applicable country export control and trade sanctions laws (“Export Control and Sanctions Laws”). Maksellent will provide the U.S. export classification(s) applicable to its Services upon request. You and Your End Users may not access, use, export, re-export, divert, transfer or disclose any portion of the Services or any related technical information or materials, directly or indirectly, in violation of Export Control and Sanctions Laws. You represent and warrant that: (i) You and Your End Users (a) are not citizens of, or located within, a country or territory that is subject to U.S. trade sanctions or other significant trade restrictions (including without limitation Cuba, Iran, North Korea, Syria, and the Crimea region of Ukraine) and that You and Your End Users will not access or use the Services, or export, re-export, divert, or transfer the Services, in or to such countries or territories; (b) are not persons, or owned 50% or more, individually or in the aggregate by persons, identified on the U.S. Department of the Treasury’s Specially Designated Nationals and Blocked Persons List or Foreign Sanctions Evaders Lists; and (c) are not persons on the U.S. Department of Commerce’s Denied Persons List, Entity List, or Unverified List, or U.S. Department of State proliferation-related lists; (ii) You and Your End Users located in China, Russia, or Venezuela are not Military End Users and will not put Maksellent’s Services to a Military End Use, as defined in 15 C.F.R. 744.21; (iii) no Content created or submitted by You or Your End Users is subject to any restriction on disclosure, transfer, download, export or re-export under the Export Control and Sanctions Laws; and (iv) You and Your End Users will not take any action that would constitute a violation of, or be penalized under, U.S. antiboycott laws administered by the U.S. Department of Commerce or the U.S. Department of the Treasury. You are solely responsible for complying with the Export Control and Sanctions Laws and monitoring them for any modifications.",
            NO_HIGH_RISK_USE: "NO HIGH RISK USE",
            NO_HIGH_RISK_USE_DESCRIPTION:
                "The Services are not designed or licensed for use in hazardous environments requiring fail-safe controls, including without limitation operation of nuclear facilities, aircraft navigation/communication systems, air traffic control, and life support or weapons systems. The Services shall not be used for or in any HIGH RISK environment.",
            INJUNCTIVE_RELIEF: "INJUNCTIVE RELIEF",
            INJUNCTIVE_RELIEF_DESCRIPTION:
                "You acknowledge that any use of the Services contrary to this Agreement, or any transfer, sublicensing, copying or disclosure of technical information or materials related to the Services, may cause irreparable injury to Maksellent, its Affiliates, suppliers and any other party authorized by Maksellent to resell, distribute, or promote the Services (“Resellers”), and under such circumstances Maksellent, its Affiliates, suppliers and Resellers will be entitled to equitable relief, without posting bond or other security, including, but not limited to, preliminary and permanent injunctive relief.",
            NO_WARRANTIES: "NO WARRANTIES",
            NO_WARRANTIES_DESCRIPTION:
                "YOU UNDERSTAND AND AGREE THAT THE SERVICES ARE PROVIDED “AS IS” AND MAKSELLENT, ITS AFFILIATES, SUPPLIERS AND RESELLERS EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT. MAKSELLENT, ITS AFFILIATES, SUPPLIERS AND RESELLERS MAKE NO WARRANTY OR REPRESENTATION REGARDING THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICES, REGARDING THE ACCURACY OR RELIABILITY OF ANY INFORMATION OBTAINED THROUGH THE SERVICES OR THAT THE SERVICES WILL MEET ANY USER’S REQUIREMENTS, OR BE UNINTERRUPTED, TIMELY, SECURE OR ERROR FREE. USE OF THE SERVICES IS AT YOUR SOLE RISK. ANY MATERIAL AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICES IS AT YOUR OWN DISCRETION AND RISK. YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOU RESULTING FROM THE USE OF THE SERVICES. THE ENTIRE RISK ARISING OUT OF USE OR PERFORMANCE OF THE SERVICES REMAINS WITH YOU. MAKSELLENT DOES NOT ASSUME ANY RESPONSIBILITY FOR RETENTION OF ANY USER INFORMATION OR COMMUNICATIONS BETWEEN USERS. MAKSELLENT CANNOT GUARANTEE AND DOES NOT PROMISE ANY SPECIFIC RESULTS FROM USE OF THE SERVICES. USE IS AT YOUR OWN RISK.",
            INDEMNIFICATION: "INDEMNIFICATION",
            INDEMNIFICATION_DESCRIPTION:
                "You agree to indemnify, defend and hold harmless Maksellent, its affiliates, officers, directors, employees, consultants, agents, suppliers and Resellers from any and all third party claims, liability, damages and/or costs (including, but not limited to, attorneys’ fees) arising from Your use of the Services, Your violation of this Agreement or the infringement or violation by You or any other user of Your account, of any intellectual property or other right of any person or entity or applicable law.",
            LIMITATION_OF_LIABILITY: "LIMITATION OF LIABILITY",
            LIMITATION_OF_LIABILITY_DESCRIPTIONN:
                "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL MAKSELLENT OR ITS AFFILIATES, SUPPLIERS OR RESELLERS BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, EXEMPLARY OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF BUSINESS INFORMATION, OR ANY OTHER PECUNIARY LOSS OR DAMAGE) ARISING OUT OF THE USE OF OR INABILITY TO USE THE SERVICES OR THE PROVISION OF OR FAILURE TO PROVIDE TECHNICAL OR OTHER SUPPORT SERVICES, WHETHER ARISING IN TORT (INCLUDING NEGLIGENCE) CONTRACT OR ANY OTHER LEGAL THEORY, EVEN IF MAKSELLENT, ITS AFFILIATES, SUPPLIERS OR RESELLERS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN ANY CASE, MAKSELLENT’S, ITS AFFILIATES’, SUPPLIERS’ AND RESELLERS’ MAXIMUM CUMULATIVE LIABILITY AND YOUR EXCLUSIVE REMEDY FOR ANY CLAIMS ARISING OUT OF OR RELATED TO THIS AGREEMENT WILL BE LIMITED TO THE AMOUNT ACTUALLY PAID BY YOU FOR THE SERVICES (IF ANY) IN THE TWELVE (12) MONTHS PRECEDING THE EVENT OR CIRCUMSTANCES GIVING RISE TO SUCH CLAIMS. Because some states and jurisdictions do not allow the exclusion or limitation of liability, the above limitation may not apply to You.",
            AGREEMENT_TO_ARBITRATE_WAIVER_OF_CLASS_ACTION:
                "AGREEMENT TO ARBITRATE; WAIVER OF CLASS ACTION",
            AGREEMENT_TO_ARBITRATE_WAIVER_OF_CLASS_ACTION_DESCRIPTION:
                " If You are located in the United States, You agree to resolve disputes only on an individual basis, through arbitration pursuant to the provisions of Exhibit A. The parties expressly waive any right to bring any action, lawsuit, or proceeding as a class or collective action, private attorney general action, or any other proceeding in which any party acts or proposes to act in a representative capacity.",
            PRIVACY_AND_OTHER_POLICIES: "PRIVACY AND OTHER POLICIES",
            PRIVACY_AND_OTHER_POLICIES_ONE:
                "se of the Services is also subject to Maksellent’s Privacy Statement, a link to which can be found by selecting “Privacy and Legal Policies” in the footer of Maksellent’s website. The Privacy Statement, and all policies noticed at,",
            PRIVACY_AND_OTHER_POLICIES_TWO:
                "are incorporated into this Agreement by this reference. Furthermore, if Your Use of the Services requires Maksellent to process any personally identifiable information (“PII” or “Personal Data”) Maksellent shall do so at all times in compliance with our Maksellent Global Data Processing Addendum",
            PRIVACY_AND_OTHER_POLICIES_THREE:
                "is incorporated in these Terms of Service. Additionally, You understand and agree that Maksellent may contact You via e-mail or otherwise with information relevant to Your use of the Services, regardless of whether You have opted out of receiving marketing communications or notices.",
            MISCELLANEOUS: "MISCELLANEOUS",
            CHOICE_OF_LAW_AND_FORUM: "Choice of Law and Forum",
            CHOICE_OF_LAW_AND_FORUM_DESCRIPTION:
                " This Agreement shall be governed by and construed under the laws of the State of California, U.S.A., as applied to agreements entered into and to be performed in California by California residents. Except as provided in Exhibit A, the Parties consent to the exclusive jurisdiction and venue of the state courts located in and serving Santa Clara County, California and the federal courts in the Northern District of California.",
            CONTRACTING_ENTITY: "Contracting Entity",
            CONTRACTING_ENTITY_DESCRIPTION:
                " In the event Your Maksellent account reflects a bill to/sold to address in India, the contracting entity under these TOS shall be Maksellent’s Affiliate, ZVC India Pvt. Ltd.",
            WAIVER_AND_SEVERABILITY: "Waiver and Severability",
            WAIVER_AND_SEVERABILITY_DESCRIPTION:
                "Failure by either Party to exercise any of its rights under, or to enforce any provision of, this Agreement will not be deemed a waiver or forfeiture of such rights or ability to enforce such provision. If any provision of this Agreement is held by a court of competent jurisdiction to be illegal, invalid or unenforceable, that provision will be amended to achieve as nearly as possible the same economic effect of the original provision and the remainder of this Agreement will remain in full force and effect.",
            GENERAL_PROVISIONS: "General Provisions",
            GENERAL_PROVISIONS_DESCRIPTION:
                "This Agreement embodies the entire understanding and agreement between the Parties respecting the subject matter of this Agreement and supersedes any and all prior understandings and agreements between the Parties respecting such subject matter, except that if You or Your company have executed a separate written agreement or you have signed an order form referencing a separate agreement governing your use of the Services, then such agreement shall control to the extent that any provision of this Agreement conflicts with the terms of such agreement. Maksellent may elect to change or supplement the terms of this Agreement from time to time at its sole discretion. Maksellent will exercise commercially reasonable business efforts to provide notice to You of any material changes to this Agreement. Within ten (10) business days of posting changes to this Agreement (or ten (10) business days from the date of notice, if such is provided), they will be binding on You. If You do not agree with the changes, You should discontinue using the Services. If You continue using the Services after such ten-business-day period, You will be deemed to have accepted the changes to the terms of this Agreement. In order to participate in certain Services, You may be notified that You are required to download software and/or agree to additional terms and conditions. Unless expressly set forth in such additional terms and conditions, those additional terms are hereby incorporated into this Agreement. This Agreement has been prepared in the English Language and such version shall be controlling in all respects and any non-English version of this Agreement is solely for accommodation purposes.",
            Exhibit_A: "Exhibit A",
            BINDING_ARBITRATION: "Binding Arbitration",
            BINDING_ARBITRATION_DESCRIPTION:
                "This Exhibit A to the TOS describes the further provisions which apply to the Binding Arbitration and Class Action Waiver.",
            DISPUTES: "Disputes",
            DISPUTES_DESCRIPTION:
                " A dispute is any controversy between You and Maksellent concerning the Services, any software related to the Services, the price of the Services, Your account, Maksellent’s advertising, marketing, or communications, Your purchase transaction or billing, or any term of this Agreement, under any legal theory including contract, warranty, tort, statute, or regulation, except disputes relating to the enforcement or validity of Your or Maksellent’s intellectual property rights. As part of the best efforts process to resolve disputes, and prior to initiating arbitration proceedings, each party agrees to provide notice of the dispute to the other party, including a description of the dispute, what efforts have been made to resolve it, and what the disputing party is requesting as resolution, to",
            SMALL_CLAIMS_COURT_AVAILABLE: "Small Claims Court Available",
            SMALL_CLAIMS_COURT_AVAILABLE_DESCRIPTION:
                "You may initiate an action in your local Small Claims Court if You meets the court’s requirements. However, if such a claim is transferred, removed or appealed to a different court, Maksellent reserves the right to require arbitration.",
            ARVITRAYION_PROCEDURE: "Arbitration Procedure",
            ARVITRAYION_PROCEDURE_DESCRIPTION:
                "Disputes not resolved pursuant to Section A or B shall be resolved through arbitration. The American Arbitration Association (“AAA”) will conduct any arbitration under its Commercial Arbitration Rules. For more information, see adr.org. Arbitration hearings will take place in the federal judicial district of Your primary business location. A single arbitrator will be appointed. The arbitrator must: (a) follow all applicable substantive Law; (b) follow applicable statutes of limitations; (c) honor valid claims of privilege; (d) issue a written decision including the reasons for the award. The arbitrator may award damages, declaratory or injunctive relief, and costs (including reasonable attorneys’ fees). Any arbitration award may be enforced (such as through a judgment) in any court with jurisdiction. Under AAA Rules, the arbitrator rules on his or her own jurisdiction, including the arbitrability of any claim; however, a court has exclusive authority to enforce the prohibition on arbitration on a class-wide basis or in a representative capacity .",
            ARBITRATION_FEES: "Arbitration Fees",
            ARBITRATION_FEES_DESCRIPTION:
                "If You are unable to afford the arbitration costs, Maksellent will advance those costs to You, subject to the arbitrator’s determination if costs should be reimbursed to Maksellent if Maksellent prevails. For disputes involving more than $75,000, the AAA rules will govern payment of filing fees and the AAA’s and arbitrator’s fees and expenses.",
            CONFLICT_WITH_AAA_RULES: "Conflict with AAA Rules",
            CONFLICT_WITH_AAA_RULES_DESCRIPTION:
                "This Agreement governs if there is a conflict with the AAA’s Commercial Arbitration Rules.",
            REQUIREMENT_TO_FILE_WITHIN_ONE_YEAR:
                "Requirement to File Within One Year",
            REQUIREMENT_TO_FILE_WITHIN_ONE_YEAR_DESCRIPTION:
                "Notwithstanding any other statute of limitations, a claim or dispute under this Agreement must be filed in Small Claims Court or noticed for arbitration within one year of when it could first be filed, or such claim will be permanently barred.",
            SEVERABILITY: "Severability",
            SEVERABILITY_DESCRIPTION:
                "If the class action waiver is found to be illegal or unenforceable as to all or some parts of a dispute, then those parts will not be arbitrated but will be resolved in court, with the balance resolved through arbitration. If any provision of this Exhibit A is found to be illegal or unenforceable, then that provision will be severed; however, the remaining provisions shall still apply and shall be interpreted to as nearly as possible achieve the original intent of this Exhibit, inclusive of the severed provision.",
        },

        PRIVACY_POLICY: {
            MAKSELLENT_PRIVACY_STATEMENT: "Maksellent Privacy Statement",
            LAST_UPDATE_DATE: "Last updated: November 1, 2021",
            PARAGRAPH:
                "This Privacy Statement describes the personal data we collect and/or process (which may include collecting, organizing, structuring, storing, using, or disclosing) to provide products and services offered directly by Maksellent Video Communications, Inc. (“Maksellent”), including Maksellent’s websites and its meetings, webinars, and messaging platform, and Maksellent App Marketplace (“Maksellent Products” or “Products”). Maksellent Products do not include products developed by Maksellent that are covered under a separate privacy policy (listed here).",
            WHAT_PERSONAL_DATA_DO_WE_RECEIVE:
                "What Personal Data Do We Receive?",
            HOW_DO_WE_USE_PERSONAL_DATA: "How Do We Use Personal Data?",
            HOW_DO_WE_SHARE_PERSONAL_DATA: "How Do We Share Personal Data?",
            WHO_CAN_SEE_AND_SHARE_MY_PERSONAL_DATA_WHEN_I_USE_MAKSELLENT:
                "Who Can See and Share My Personal Data When I Use Maksellent?",
            PRIVACY_RIGHT_AND_CHOICES: "Privacy Rights and Choices",
            CHILDREN: "Children",
            HOW_TO_CONTACT_US: "How to Contact Us",
            RETENTION: "Retention",
            EUROPEAN_DATA_PROTECTION_SPECIFIC_INFORMATION:
                "European Data Protection Specific Information",
            CALIFORNIA_PRIVACY_RIGHTS: "California Privacy Rights",
            CHANGES_TO_THIS_PRIVACY_STATEMENT:
                "Changes to This Privacy Statement",
            WHAT_PERSONAL_DATA_DO_WE_RECEIVE_DESCRIPTION:
                "Personal data is any information from or about an identified or identifiable person, including information that Maksellent can associate with an individual person. We may collect, or process on behalf of our customers, the following categories of personal data when you use or interact with Maksellent Products",
            ACCOUNT_INFORMATION: "Account Information",
            ACCOUNT_INFORMATION_DESCRIPTION:
                " Information associated with an account that licenses Maksellent Products, which may include administrator name, contact information, account ID, billing information, and account plan information.",
            PROFILE_AND_PARTICIPANT_INFORMATION:
                "Profile and Participant Information",
            PROFILE_AND_PARTICIPANT_INFORMATION_DESCRIPTION:
                "Information associated with the Maksellent profile of a user who uses Maksellent Products under a licensed account or that is provided by an unlicensed participant joining a meeting, which may include name, display name, picture, email address, phone number, job information, stated locale, user ID, or other information provided by the user or their account owner.",
            CONTACTS_AND_CALENDAR_INTEGRATION:
                "Contacts and Calendar Integrations",
            CONTACTS_AND_CALENDAR_INTEGRATION_DESCRIPTION:
                " Contact information added by accounts or their users to create contact lists on Maksellent Products, which may include contact information a user integrates from a third-party app. Users can also integrate their calendars from other services with their Maksellent profile or account.",
            SETTINGS: "Settings",
            SETTINGS_DESCRIPTION:
                " Information associated with the preferences and settings on a Maksellent account or user profile, which may include audio and video settings, recording file location, screen sharing settings, and other settings and configuration information.",
            REGISTRATION_INFORMATION: "Registration Information",
            REGISTRATION_INFORMATION_DESCRIPTION:
                " Information people provide when registering for a Maksellent meeting, webinar or recording, which may include name and contact information, responses to registration questions, and other registration information requested by the host.",
            DEVICE_INFORMATION: "Device Information",
            DEVICE_INFORMATION_DESCRIPTION:
                "Information about the computers, phones, and other devices people use when interacting with Maksellent Products, which may include information about the speakers, microphone, camera, OS version, hard disk ID, PC name, MAC address, IP address (which may be used to infer general location at a city or country level), device attributes (like operating system version and battery level), WiFi information, and other device information (like Bluetooth signals).",
            MEETING_WEBINAR_AND_MESSAGING_CONTENT_AND_CONTEXT:
                "Meeting, Webinar, and Messaging Content and Context",
            MEETING_WEBINAR_AND_MESSAGING_CONTENT_AND_CONTEXT_DESCRIPTION:
                "Content generated in meetings, webinars, or messages that are hosted on Maksellent Products, which may include audio, video, in-meeting messages, chat messaging content, transcriptions, written feedback, responses to polls and Q&A, and files, as well as related context, such as invitation details, meeting or chat name, or meeting agenda. Content may contain your voice and image, depending on the account owner’s settings, what you choose to share, your settings, and what you do on Maksellent Products.",
            PRODUCT_AND_WEBSITE_USAGE: "Product and Website Usage",
            PRODUCT_AND_WEBSITE_USAGE_DESCRIPTION:
                " Information about how people and their devices interact with Maksellent Products, such as: when participants join and leave a meeting; whether participants sent messages and who they message with; performance data; mouse movements, clicks, keystrokes or actions (such as mute/unmute or video on/off), and other user inputs that help Maksellent to understand feature usage, improve product design, and suggest features; which third-party apps users add to a meeting or other Product and what information and actions the app is authorized to access and perform; use of third-party apps and the Maksellent App Marketplace; features used (such as screen sharing, emojis, or filters); and other usage information and metrics. This also includes information about when and how people visit and interact with Maksellent’s websites, including what pages they accessed, their interaction with the website features, and whether or not they signed up for a Maksellent Product.",
            COMMUNICATIONS_WITH_MAKSELLENT: "Communications with Maksellent",
            COMMUNICATIONS_WITH_MAKSELLENT_DESCRIPTION:
                "Information about your communications with Maksellent, including relating to support questions, your account, and other inquiries.",
            INFORMATION_FROM_PARTNERS: "Information from Partners",
            INFORMATION_FROM_PARTNERS_DESCRIPTION:
                "Maksellent obtains information about account owners and their users from third-party companies, such as market data enrichment services, including information about an account owner’s company size or industry, contact information, or activity of certain enterprise domains. Maksellent may also obtain information from third-party advertising partners who deliver ads displayed on Maksellent Products, such as whether you clicked on an ad they showed you.",
            HOW_DO_WE_USE_PERSONAL_DATA_DESCRIPTION_ONE:
                "Maksellent employees do not access meeting, webinar, or messaging content (specifically, audio, video, files, and messages) unless directed by an account owner, or as required for legal, safety, or security reasons, as discussed below. Maksellent uses personal data to conduct the following activities",
            PROVIDE_MAKSELLENT_PRODUCTS_AND_SERVICES:
                "Provide Maksellent Products and Services",
            PROVIDE_MAKSELLENT_PRODUCTS_AND_SERVICES_DESCRIPTION:
                "To provide Products, features, and services to account owners, their users, and those they invite to join meetings and webinars hosted on their accounts, including to customize Maksellent Product features and recommendations for accounts or their users. Maksellent also uses personal data, including contact information, to route invitations and messages to recipients when people send invitations and messages using Maksellent Products. This may also include using personal data for customer support, which may include accessing audio, video, files, and messages, at the direction of the account owner or their users. We also use personal data to manage our relationship and contracts with account owners, including billing, compliance with contractual obligations, and related administration.",
            PRODUCT_RESEARCH_AND_DEVELOPMENT:
                "Product Research and Development",
            PRODUCT_RESEARCH_AND_DEVELOPMENT_DESCRIPTION:
                "To develop, test, and improve Maksellent Products, including, for example, content-related features (such as background filters), and to troubleshoot products and features.",
            MARKETING_PROMOTIONS_AND_THIRD_PARTY_ADVERTISING:
                "Marketing, Promotions, and Third-Party Advertising",
            MARKETING_PROMOTIONS_AND_THIRD_PARTY_ADVERTISING_DESCRIPTION:
                " To permit Maksellent and/or its third party marketing partners to market, advertise, and promote Maksellent Products, features, and services, including based on your product usage, information we receive from third-party partners, or if you visit our websites, information about how and when you visit, and your interactions with them. We may also use cookies or similar technology, including from third-party advertising partners, to show you ads within Maksellent Products about products, services, or causes from third parties. Maksellent does NOT use meeting, webinar, or messaging content (specifically, audio, video, files, and messages) for any marketing, promotions or third-party advertising purposes.",
            AUTHENTICATION_INTEGRITY_SECURITY_AND_SAFETY:
                "Authentication, Integrity, Security, and Safety",
            AUTHENTICATION_INTEGRITY_SECURITY_AND_SAFETY_DESCRIPTION:
                "To authenticate accounts and activity, detect, investigate, and prevent malicious conduct or unsafe experiences, address security threats, protect public safety, and secure Maksellent Products.",
            COMMUNICATE_WITH_YOU: "Communicate with You",
            COMMUNICATE_WITH_YOU_DESCRIPTION:
                "We use personal data (including contact information) to communicate with you about Maksellent Products, features, and services, including product updates, your account, and changes to our policies and terms. We also use your information to respond to you when you contact us.",
            LEGAL_REASONS: "Legal Reasons",
            LEGAL_REASONS_DESCRIPTION:
                "To comply with applicable law or respond to valid legal process, including from law enforcement or government agencies, to investigate or participate in civil discovery, litigation, or other adversarial legal proceedings, and to enforce or investigate potential violations of our Terms of Service or policies.",
            HOW_DO_WE_USE_PERSONAL_DATA_DESCRIPTION_TWO:
                "Maksellent uses advanced tools to automatically scan content such as virtual backgrounds, profile images, and files uploaded or exchanged through chat, for the purpose of detecting and preventing violations of our terms or policies and illegal or other harmful activity, and its employees may investigate such content where required for legal, safety, or security reasons.",
            HOW_DO_WE_SHARE_PERSONAL_DATA_DESCRIPTION:
                "Maksellent provides personal data to third parties only with consent or in one of the following circumstances (subject to your prior consent where required under applicable law):",
            RESELLERS: "Resellers",
            RESELLERS_DESCRIPTION:
                "If an account owner licensed or purchased Maksellent Products from a third-party reseller of Maksellent Products, the reseller may be able to access personal data and content for users, including meetings, webinars, and messages hosted by the account owner.",
            VENDORS: "Vendors",
            VENDORS_DESCRIPTION:
                "Maksellent works with third-party service providers to provide, support, and improve Maksellent Products and technical infrastructure, and for business services such as payment processing. Maksellent may also work with third-party service providers to provide advertisements and business analytics regarding Maksellent Products. These vendors can access personal data subject to contractual and technical requirements for protecting personal data and prohibiting them from using personal data for any purpose other than to provide services to Maksellent or as required by law.",
            FOR_LEGAL_REASONS: "For Legal Reasons",
            FOR_LEGAL_REASONS_DESCRIPTION:
                "Maksellent may share personal data as needed to: (1) comply with applicable law or respond to, investigate, or participate in valid legal process and proceedings, including from law enforcement or government agencies; (2) enforce or investigate potential violations of its Terms of Service or policies; (3) detect, prevent, or investigate potential fraud, abuse, or safety and security concerns, including threats to the public; (4) meet our corporate and social responsibility commitments; (5) protect our and our customers’ rights and property; and (6) resolve disputes and enforce agreements.",
            MARKETING_ADVERTISING_AND_ANALYTICS_PARTNERS:
                "Marketing, Advertising, and Analytics Partners",
            MARKETING_ADVERTISING_AND_ANALYTICS_PARTNERS_DESCRIPTION:
                "Maksellent uses third-party marketing, advertising, and analytics providers: to provide statistics and analysis about how people are using Maksellent Products and our website; to provide advertising and marketing for Maksellent Products, including targeted advertising based on your use of our website; and to show you third-party advertising within Maksellent Products. These third-party partners may receive information about your activities on Maksellent’s website through third-party cookies placed on Maksellent’s website. To opt out of our use of third-party cookies that share data with these partners, visit our cookie management tool, available Cookies Settings. Where required by law, Maksellent will first obtain your consent before engaging in the marketing or advertising activities described.",
            CORPORATE_AFFILIATES: "Corporate Affiliates",
            CORPORATE_AFFILIATES_DESCRIPTION:
                "Maksellent shares personal information with corporate affiliates, such as Maksellent Voice Communications, Inc., to provide integrated and consistent experiences across Maksellent Products (such as enabling a user to integrate a Maksellent Phone call into a meeting) to detect, investigate, and prevent fraud, abuse, and threats to public safety.",
            CHANGE_OF_CONTROL: "Change of Control",
            CHANGE_OF_CONTROL_DECRIPTION:
                "We may share personal data with actual or prospective acquirers, their representatives and other relevant participants in, or during negotiations of, any sale, merger, acquisition, restructuring, or change in control involving all or a portion of Maksellent’s business or assets, including in connection with bankruptcy or similar proceedings.",
            WHO_CAN_SEE_AND_SHARE_MY_PERSONAL_DATA_WHEN_I_USE_MAKSELLENT_DESCRIPTION:
                "When you send messages or join meetings and webinars on Maksellent, other people and organizations, including third parties outside the meeting, webinar, or message, may be able to see content and information that you share:",
            ACCOUNT_OWNER: "Account Owner",
            ACCOUNT_OWNER_ONE:
                "An account owner is the organization or individual that signs up for a Maksellent account. Typically, an account owner designates one or more people (called an “administrator”) to manage their account and can grant privileges to users on the account. Depending on their license with Maksellent, the account owner can authorize additional users on their account, and the account owner can create and/or access the profile information for all users on their account. The account owner and their users can invite others (including guests not on their account) to meetings or webinars hosted on their account.",
            ACCOUNT_OWNER_TWO:
                "Maksellent gives account owners controls and features that they can use to determine whether certain types of content, such as recordings or out-of-meeting messages, can be created or sent, and what third-party apps can be used, for meetings and webinars hosted on their account. Depending on their settings, account owners and the people they designate can access personal data for people who join meetings and webinars on their account or send messages to users on their account. Specifically, account owners may have access to:",
            ACCOUNT_USAGE: "Account Usage",
            PRODUCT_USAGE: "Product Usage",
            PRODUCT_USAGE_DESCRIPTION:
                "Information about how people and their devices interact with their account, which may include who sent messages to their users in chat, email addresses, IP addresses, device information, and other information about who joined meetings or webinars on their account, whether users viewed or downloaded a recording, how long people participated in their meetings, the time a message was sent, information about Maksellent Phone integrations, and other usage information and feedback metrics.",
            PARTICIPANT_LIST: "Participant List",
            PARTICIPANT_LIST_DESCRIPTION:
                " Information about the participants in a Maksellent meeting, webinar, or chat, which may include name, display name, email address, phone number, and participant or user ID.",
            REGISTRATION_INFORMATION_DESCRIPTION_NEW:
                " Information provided during registration for a webinar, meeting, or recording hosted by the account.",
            MAKSELLENT_CHAT_OUT_OF_MEETING_MESSAGE:
                "Maksellent Chat Out-of-Meeting Messages",
            MAKSELLENT_CHAT_OUT_OF_MEETING_MESSAGE_DESCRIPTION:
                "If enabled on their account, account owners can see information about who sent and received out-of-meeting messages to users on their account along with information about the message (for example, date and time, and number of participants).  Depending on their settings, account owners also can see sender and receiver information, and other messaging data, along with the content of messages sent to and from users on their account, unless the account owner has enabled Advanced Chat Encryption.",
            IN_MEETING_WEBINAR_MESSAGES: "In-Meeting/Webinar Messages",
            IN_MEETING_WEBINAR_MESSAGES_DESCRIPTION:
                "Depending on their settings, account owners can see sender and receiver information, along with the content of messages sent to and from users on their account, in the following circumstances:",
            MESSAGE_SENT_TO_EVERYONE_IN_A_MEETING_THAT_IS_RECORDED:
                "Messages sent to Everyone in a meeting that is recorded",
            MESSAGE_SENT_TO_PANELISTS_IN_A_WEBINAR_THAT_IS_RECORDED:
                "Messages sent to panelists in a webinar that is recorded",
            DIRECT_MESSAGES_IF_THE_ACCOUNT_OWNER_HAS_ENABLED_ARCHIVING:
                "Direct messages if the account owner has enabled archiving",
            RECORDINGS: "Recordings",
            RECORDINGS_DESCRIPTION:
                "Account owners can watch the content of recordings of meetings and webinars hosted on their account.  They can also view a transcript of meeting audio, if enabled.",
            POLLING_QA_AND_FEEDBACK: "Polling, Q&A, and Feedback",
            POLLING_QA_AND_FEEDBACK_DESCRIPTION:
                "Account owners can see information about who provided responses to their polls, Q&A, or post meeting or webinar feedback requests, including name and contact information, together with the responses or feedback, unless responses are submitted anonymously.",
            MEETING_HOSTS_AND_PARTICIPANTS: "Meeting Hosts and Participants",
            MEETING_HOSTS_AND_PARTICIPANTS_DESCRIPTION:
                "Hosts and other participants in a meeting may be able to see your email, display name, and profile picture.  Meeting hosts and participants can also see and (depending on the account owner’s settings) record or save meeting content, audio transcripts, messages sent to Everyone or to them directly, and files, whiteboards, or other information shared during a meeting.  Hosts may also be able to see responses to Q&A and polls generated during the meeting.",
            WEBINAR_PANELISTS_AND_ATTENDEES: "Webinar Panelists and Attendees",
            WEBINAR_PANELISTS_AND_ATTENDEES_DESCRIPTION:
                "Only panelists may be visible to attendees during a webinar, but attendees who agree to unmute can be heard by other attendees.  If an attendee agrees to become a panelist during a webinar, they may be visible to other attendees, depending on settings.  Panelists and attendees may be able to see the name of a participant who asks a question during a Q&A, along with their question, unless the participant submits the question anonymously.",
            LIVESTREAMS: "Livestreams",
            LIVESTREAMS_DESCRIPTION:
                "Meeting and webinar hosts can choose to livestream to a third-party site or service, which means anyone with access to the livestream will be able to see the meeting or webinar.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS:
                "Third-Party Apps and Integrations",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_ONE:
                "Account owners can choose to add third-party apps to their account and the Maksellent Products they use, including via use of the Maksellent App Marketplace, and they can also control whether their users can add and use specific third-party apps, including in meetings, webinars, and chats hosted on their account.  Depending on their settings, account owners and their users and guests can share your personal data and content with third-party apps and integrations they approve, which may include all of the personal data available to account owners, hosts, and participants listed above, such as account information, profile and contact information, registration information, participants list, settings, content, product usage, and device information.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_TWO:
                "Other participants in the meeting may be able to see the third-party app that you are using in a meeting, if the third-party app is receiving real-time features and information from the meeting.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_THREE:
                "Third-party developers may also integrate or embed Maksellent meetings into their website or app experiences or build versions of Maksellent that enable access to Maksellent Products from a third-party app.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_FOUR:
                "Personal information shared by account owners and users with third-party apps and integrations is collected and processed in accordance with the app developers’ terms and privacy policies, not Maksellent’s.",
            PRIVACY_RIGHTS_AND_CHOICES: "Privacy Rights and Choices",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION:
                "If you are in the European Economic Area (EEA), Switzerland, or the UK, or a resident of California, please refer to the respective dedicated sections below. Otherwise, at your request, and as required by applicable law, we will:",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION_ONE:
                "Inform you of what personal data we have about you that is under our control;",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION_TWO:
                "Amend or correct such personal data or any previous privacy preferences you selected, or direct you to applicable tools; and/or",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION_THREE:
                "Delete such personal data or direct you to applicable tools.",
            PRIVACY_RIGHTS_AND_CHOICES_PARAGRAPH_ONE:
                "In order to exercise any of your rights as to personal data controlled by Maksellent, or if you have any other questions about our use of your personal data, please send a request to",
            PRIVACY_RIGHTS_AND_CHOICES_PARAGRAPH_TWO:
                "Please identify yourself and, for information relating to Maksellent Products, specify your account and/or user information and other information to enable us to authenticate and respond to your request. Where legally permitted, we may decline to process requests that are unreasonably repetitive or systematic, require disproportionate",
            PRIVACY_RIGHTS_AND_CHOICES_PARAGRAPH_THREE:
                "technical effort, or jeopardize the privacy of others. As an account owner or a user under a licensed account, you may also take steps to affect your personal data by visiting your account and modifying your personal data directly.",
            CHILDREN_PARAGRAPH_ONE:
                "Maksellent does not allow children under the age of 16 to sign up for a Maksellent account.",
            CHILDREN_PARAGRAPH_TWO:
                "For educational organizations that use Maksellent Products to provide educational services to children under 18, Maksellent’s Children’s Educational Privacy Statement is available here.",
            HOW_TO_CONTACT_US_DESCRIPTION:
                "To exercise your rights or if you have any privacy-related questions or comments related to this Privacy Statement, please send an email to",
            HOW_TO_CONTACT_US_ADDRESS:
                "You can also contact us by writing to the following address:",
            MAKSELLENT_VIDEO_COMMUNICATIONS: "Maksellent Video Communications,",
            INC_ATTENTION_DATA_PRIVACY_OFFICER:
                "Inc. Attention: Data Privacy Officer",
            ALMADEN_BLVD_SUITE: "55 Almaden Blvd, Suite 600",
            SAN_JOSE_CA: "San Jose, CA 95113",
            HOW_TO_CONTACT_US_UK_ADDRESS:
                "Or to our representative in the EU or UK:",
            LIONHEART_SQUARED_LTD: "Lionheart Squared Ltd",
            ATTN_DATA_PRIVACY: "Attn: Data Privacy",
            PEMBROKE_HOUSE: "2 Pembroke House",
            UPPER_PEMBROKE_STREET: "Upper Pembroke Street 28-32",
            DUBLIN: "Dublin",
            DO_EK: "DO2 EK84",
            REPUBLIC_OF_LRELAND: "Republic of lreland",
            EMAIL: "email:",
            LIONHEART_SQUARED_LIMITED: "Lionheart Squared Limited",
            GLASSHOUSE_STUDIOS: "17 Glasshouse Studios",
            FRYERN_COURT_ROAD: "Fryern Court Road",
            FORDINGBRIDGE: "Fordingbridge",
            HAMPSHIRE: "Hampshire",
            SP_QX: "SP6 1QX",
            UNITED_KINGDOM: "United Kingdom",
            CONTACT: "Contact:",
            DATA_PROTECTION_OFFICER:
                "You can contact our Data Protection Officer by sending an email to",
            RETENTION_DESCRIPTION:
                "We retain personal data for as long as required to engage in the uses described in this Privacy Statement, unless a longer retention period is required by applicable law.",
            RETENTION_RULES:
                "The criteria used to determine our retention periods include the following:",
            RETENTION_RULES_ONE:
                "The length of time we have an ongoing relationship with you and provide Maksellent Products to you (for example, for as long as you have an account with us or keep using our Products);",
            RETENTION_RULES_TWO:
                "Whether account owners modify or their users delete information through their accounts;",
            RETENTION_RULES_THREE:
                "Whether we have a legal obligation to keep the data (for example, certain laws require us to keep records of your transactions for a certain period of time before we can delete them); or",
            RETENTION_RULES_FOUR:
                "Whether retention is advisable in light of our legal position (such as in regard to the enforcement of our agreements, the resolution of disputes, and applicable statutes of limitations, litigation, or regulatory investigation).",
            DATA_SUBJECTS_RIGHTS: "Data Subjects Rights",
            DATA_SUBJECTS_RIGHTS_DESCRIPTION:
                "If you are in the EEA, Switzerland, or the UK, your rights in relation to your personal data processed by us as a controller specifically include:",
            RIGHT_OF_ACCESS_AND_OR_PORTABILITY:
                "Right of access and/or portability",
            RIGHT_OF_ACCESS_AND_OR_PORTABILITY_DESCRIPTION:
                "You have the right to access any personal data that we hold about you and, in some circumstances, have that data provided to you so that you can provide or “port” that data to another provider;",
            RIGHT_OF_ERASURE: "Right of erasure",
            RIGHT_OF_ERASURE_DESCRIPTION:
                "In certain circumstances, you have the right to the erasure of personal data that we hold about you (for example, if it is no longer necessary for the purposes for which it was originally collected);",
            RIGHT_TO_OBJECT_TO_PROCESSING: "Right to object to processing",
            RIGHT_TO_OBJECT_TO_PROCESSING_DESCRIPTION:
                "In certain circumstances, you have the right to request that we stop processing your personal data and/or stop sending you marketing communications;",
            RIGHT_TO_RECTIFICATION: "Right to rectification",
            RIGHT_TO_RECTIFICATION_DESCRIPTION:
                "You have the right to require us to correct any inaccurate or incomplete personal data;",
            RIGHT_TO_RESTRICT_PROCESSING: "Right to restrict processing",
            RIGHT_TO_RESTRICT_PROCESSING_DESCRIPTION:
                "You have the right to request that we restrict processing of your personal data in certain circumstances (for example, where you believe that the personal data we hold about you is not accurate or lawfully held).",
            RIGHT_TO_RESTRICT_PROCESSING_PARAGRAPH_ONE:
                "In order to exercise any of your rights as to personal data controlled by Maksellent, or if you have any other questions about our use of your personal data, please send a request at the contact details specified in the How to Contact Us section of this Privacy Statement. Please note that we may request you to provide us with additional information in order to confirm your identity and ensure that you are entitled to access the relevant personal data.",
            RIGHT_TO_RESTRICT_PROCESSING_PARAGRAPH_TWO:
                "You also have the right to lodge a complaint to a data protection authority. For more information, please contact your local data protection authority.",
            LEGAL_BASIS_FOR_PROCESSING_PERSONAL_DATA:
                "Legal Basis for Processing Personal Data",
            LEGAL_BASIS_FOR_PROCESSING_PERSONAL_DATA_DESCRIPTION:
                "We only use your information in a lawful, transparent, and fair manner. Depending on the specific personal data concerned and the factual context, when Maksellent processes personal data as a controller for individuals in regions such as the EEA, Switzerland, and the UK, we rely on the following legal bases as applicable in your jurisdiction:",
            AS_NECESSARY_FOR_OUR_CONTACT: "As necessary for our contract",
            AS_NECESSARY_FOR_OUR_CONTACT_DESCRIPTION:
                "When we enter into a contract directly with you, we process your personal data on the basis of our contract in order to prepare and enter into the contract, as well as to perform and manage our contract (i.e., providing Maksellent Products, features and services to account owners, their users, and those they invite to join meetings and webinars hosted on their accounts, and manage our relationship and contract, including billing, compliance with contractual obligations, and related administration). If we do not process your personal data for these purposes, we may not be able to provide you with all Products, features, and services;",
            CONSOSTENT_WITH_SPECIFIC_REVOCABLE_CONSENTS:
                "Consistent with specific revocable consents",
            CONSOSTENT_WITH_SPECIFIC_REVOCABLE_CONSENTS_DESCRIPTION:
                "We rely on your prior consent in order to utilize cookies to engage advertising and analytics partners to deliver tailored advertising and analysis of our website usage. You have the right to withdraw your consent at any time by visiting our cookie management tool, available Cookies Settings;",
            AS_NECESSARY_TO_COMPLY_WITH_OUR_LEGAL_OBLIGATIONS:
                "As necessary to comply with our legal obligations",
            AS_NECESSARY_TO_COMPLY_WITH_OUR_LEGAL_OBLIGATIONS_DESCRIPTION:
                "We process your personal data to comply with the legal obligations to which we are subject for the purposes of compliance with EEA laws, regulations, codes of practice, guidelines, or rules applicable to us, and for responses to requests from, and other communications with, competent EEA public, governmental, judicial, or other regulatory authorities. This includes detecting, investigating, preventing, and stopping fraudulent, harmful, unauthorized, or illegal activity (“fraud and abuse detection”) and compliance with privacy laws;",
            TO_PROTECT_YOUR_VITAL_INTERESTS_OR_THOSE_OF_OTHERS:
                "To protect your vital interests or those of others",
            TO_PROTECT_YOUR_VITAL_INTERESTS_OR_THOSE_OF_OTHERS_DESCRIPTION:
                "We process certain personal data in order to protect vital interests for the purpose of detecting and preventing illicit activities that impact vital interests and public safety, including child sexual abuse material; and",
            AS_NECESSARY_FOR_OUR_LEGITIMATE_INTERESTS:
                "As necessary for our (or others’) legitimate interests, unless those interests are overridden by your interests or fundamental rights and freedoms, which require protection of personal data",
            AS_NECESSARY_FOR_OUR_LEGITIMATE_INTERESTS_DESCRIPTION_ONE:
                "We process your personal data based on such legitimate interests to (i) enter and perform the contract with the account",
            AS_NECESSARY_FOR_OUR_LEGITIMATE_INTERESTS_DESCRIPTION_TWO:
                "owner and/or reseller providing you with the Products (which includes billing, compliance with contractual obligations, and related administration and support); (ii) develop, test, and improve our Products and troubleshoot products and features; (iii) ensure authentication, integrity, security, and safety of accounts, activity, and Products, including detect and prevent malicious conduct and violations of our terms and policies, prevent or investigate bad or unsafe experiences, and address security threats; (iv) send marketing communications, advertising, and promotions related to the Products; and (v) comply with non-EEA laws, regulations, codes of practice, guidelines, or rules applicable to us and respond to requests from, and other communications with, competent non-EEA public, governmental, judicial, or other regulatory authorities, as well as meet our corporate and social responsibility commitments, protect our rights and property and the ones of our customers, resolve disputes, and enforce agreements.",
            INTERNATIONAL_DATA_TRANSFERS: "International Data Transfers",
            INTERNATIONAL_DATA_TRANSFERS_PRAGRAPH_ONE:
                "Maksellent operates globally, which means personal data may be transferred, stored (for example, in a data center), and processed outside of the country or region where it was initially collected where Maksellent or its service providers have customers or facilities – including in countries where meeting participants or account owners hosting meetings or webinars that you participate in or receiving messages that you send are based.",
            INTERNATIONAL_DATA_TRANSFERS_PRAGRAPH_TWO:
                "Therefore, by using Maksellent Products or providing personal data for any of the purposes stated above, you acknowledge that your personal data may be transferred to or stored in the United States where we are established, as well as in other countries outside of the EEA, Switzerland, and the UK. Such countries may have data protection rules that are different and less protective than those of your country.",
            INTERNATIONAL_DATA_TRANSFERS_PRAGRAPH_THREE:
                "We protect your personal data in accordance with this Privacy Statement wherever it is processed and take appropriate contractual or other steps to protect it under applicable laws. Where personal data of users in the EEA, Switzerland, or the UK is being transferred to a recipient located in a country outside the EEA, Switzerland, or the UK which has not been recognized as having an adequate level of data protection, we ensure that the transfer is governed by the European Commission’s standard contractual clauses. Please contact us if you would like further information in that respect.",
            CALIFORNIA_CONSUMER_PRIVACY_ACT: "California Consumer Privacy Act",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_DESCRIPTION:
                "Under the California Consumer Privacy Act of 2018 (CCPA), California residents may have a right to:",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_ACCESS:
                "Access the categories and specific pieces of personal data Maksellent has collected, the categories of sources from which the personal data is collected, the business purpose(s) for collecting the personal data, and the categories of third parties with whom Maksellent has shared personal data;",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_DELETE:
                "Delete personal data under certain circumstances; and",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_OPT_OUT_OF_THE_SALE_ONE:
                "Opt out of the “sale” of personal data. We do not sell your personal data in the conventional sense. However, like many companies, we use advertising services that try to tailor online ads to your interests based on information collected via cookies and similar technologies about your online activity. This is called interest-based advertising. The CCPA’s statutory definition of the term “sale” is broad and may include interest-based advertising. You can get more information and opt out of the use of cookies on our sites",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_OPT_OUT_OF_THE_SALE_TWO:
                "for interest-based advertising purposes by clicking the Do Not Sell My Personal InformationDo Not Sell My Personal Information link, also on our homepage, and setting your preferences. You will",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_OPT_OUT_OF_THE_SALE_THREE:
                "need to set your preferences from each device and each web browser from which you wish to opt out. This feature uses a cookie to remember your preference, so if you clear all cookies from your browser, you will need to reset your settings.",
            CALIFORNIA_CONSUMER_PARAGRAPH_ONE:
                "Maksellent will not discriminate against you for exercising any of these rights, which is further in line with your rights under the CCPA.",
            CALIFORNIA_CONSUMER_PARAGRAPH_TWO:
                "To exercise your rights, contact us by emailing",
            CALIFORNIA_CONSUMER_PARAGRAPH_THREE:
                "We will acknowledge receipt of your request within 10 business days, and provide a substantive response within 45 calendar days, or inform you of the reason and extension period (up to 90 days) in writing.",
            CALIFORNIA_CONSUMER_PARAGRAPH_FOUR:
                "Under the CCPA, only you or an authorized agent may make a request related to your personal data. Note that to respond to your requests to access or delete personal data under the CCPA, we must verify your identity. We may do so by requiring you to log into your Maksellent account (if applicable), provide information relating to your account (which will be compared to information we have, such as profile information), give a declaration as to your identity under penalty of perjury, and/or provide additional information. You may designate an authorized agent to submit your verified consumer request by providing written permission and verifying your identity, or through proof of power of attorney.",
            CALIFORNIA_CONSUMER_PARAGRAPH_FIVE:
                "or calling +1-888-799-9666. To opt out of the use of cookies on our sites for interest-based advertising purposes, follow the instructions above.",
            CALIFORNIAS_SHINE_THE_LIGHT_LAW: "California’s Shine the Light Law",
            CALIFORNIAS_SHINE_THE_LIGHT_LAW_DESCRIPTION:
                "California Civil Code Section 1798.83, also known as “Shine The Light” law, permits California residents to annually request information regarding the disclosure of your Personal Information (if any) to third parties for the third parties’ direct marketing purposes in the preceding calendar year. We do not share Personal Information with third parties for the third parties’ direct marketing purposes.",
            CHANGES_TO_THIS_PRIVACY_STATEMENT_DESCRIPTION:
                "We may update this Privacy Statement periodically to account for changes in our collection and/or processing of personal data, and will post the updated Privacy Statement on our website, with a “Last Updated” date at the top. If we make material changes to this Privacy Statement, we will notify you and provide you an opportunity to review before you choose to continue using our Products.",
        },

        CALENDAR: {
            CREATE_TASK: "Create Task",
            EVENTS: "Events",
            COMPLETED_TASKS: "Completed Tasks",
            PENDING_TASKS: "Pending Tasks",
            MY_CALENDARS: "My Calendars",
            WORK: "Work",
            TRIP: "Trip",
            FUNCTIONS: "Functions",
            EVENT: "Event",
            CHOOSE_START_TIME: "Choose Start Time",
            ALL_DAY: "All Day",
            CHOOSE_END_TIME: "Choose End Time",
            SCHEDULE: "Schedule",
            SELECT_SCHEDULE: "Select Schedule",
            PRIVATE_TASK: "Private Task",
            OPEN_TASK_ON_MY_TASKS_AFTER_SAVE:
                "Open task on My tasks after save",
            TIME_ZONE: "TIME ZONE:",
            ADD_GUEST: "Add Guests",
            SELECT_GUEST: "Select Guest",
            MONTH: "MONTH",
            DAILY: "Daily",
            WEEKLY: "Weekly",
            MOVE_TO_TODAY: "Move to Today",
            HH: "HH",
            MARK_COMPLETED: "MARK COMPLETED"
        },

        CONTACT: {
            CHAT: "Chat",
            REACTION: "Reactions",
            THREADS: "Threads",
            LIKE_SMALL: "Like",
            SEARCH_CONTACT: "Search Contacts",
            CONTACT_LOG: "Contact Log",
            TO_DO_S: "TO DO’s",
            CONTACTS: "Contacts",
            CONTACTS_SMALL: "contacts",
            ADD_EVENT_APPOINTMENT: "Add Event/Appointment",
            ADD_TO_DO: "Add To-Do",
            INTERNAL: "Internal",
            EXTERNAL: "External",
            EDIT_CONTACT: "Edit Contact",
            ENTER_A_COMMENT: "Enter a comment",
            ENTER_MESSAGE: "Enter message",
            TODAY: "Today"
        },

        FILE_EDITOR: {
            QUEUE_PROGRESS: "Queue progress:",
            QUEUE_LENGTH: "Queue length:",
            UPLOAD_QUEUE: "Upload queue",
            SINGLE: "Single",
            MULTIPLE: "Multiple",
            DROP_PHOTOS_HERE: "Drop Photos Here",
            SELECTFILES: "SelectFiles",
            USER_DETAIL: "User Detail",
            LOADING_DATA: "Loading data...",
            NO_DATA: "No data."
        },

        BIP_BH_WELCOME: {
            TITLE: "Welcome to Bounty Hunters",
            MESSAGE: "Only real bounty hunters can win prizes here.",
            BUTTON: "Join To Missions",
        },

        BIP_BH_MISSION: {
            TITLE: "Easy Mission",
            MESSAGE: "Download and use BipMeet",
            BUTTON: "Do It",
            POINT: "Points",
        },

        BIP_BH_PROGRESS: {
            TIMER: "Timer:",
            TITLE: "Bounty Hunters",
            MESSAGE: "Only real bounty hunters can win prizes here.",
            BUTTON: "Go to Mission",
            DAYS: "Days",
            HOURS: "Hours",
            MINUTES: "Minutes",
            SECONDS: "Seconds",
        },

        BIP_CONTEST: {
            TITLE: "Contests",
            MESSAGE: "Burada sadece gerçek ödül avcıları ödül kazanabilir.",
            BUTTON1: "Turkcell Bounty Hunters",
            BUTTON2: "Youtube Bounty Hunters",
        },

        BIP_EARNED: {
            TITLE: "Congrats",
            MESSAGE: "You earned 2 GB per week",
            BUTTON: "Share on social media",
        },

        BIP_EARNED_LIST: {
            TITLE: "Turkcell Bounty Hunters",
            MESSAGE: "Total Points Earned",
            ITEM1: "10+ Year Turkcell members",
            ITEM2: "BipMeet download and use",
        },

        BIP_MISSION_LIST: {
            MISSIONTYPE: "Easy Missions",
            MENU1: "Active Missions",
            MENU2: "Old Missions",
            MENU3: "Help",
            TITLE: "Turkcell Bounty Hunters",
            BUTTON: "Start New Race",
        },

        BIP_MISSION_TYPE: {
            TITLE: "Turkcell Bounty Hunters",
            SUBTITLE: "Mission Types",
            MISSIONTYPE1: "Easy Missions",
            MISSIONTYPE2: "Normal Missions",
            MISSIONTYPE3: "Super Missions",
        },
    },
};
